import { AnyAction } from "@reduxjs/toolkit";
import { useIPContext } from "app/pages/InteractiveProposal/InteractiveProposalProvider";
import {
  resetgetLoanPlanProjectionState,
  resetPlanAdminSplitDollarState,
  resetPlanSplitDollarState,
  resetpostCSVDataState,
} from "app/redux";
import { contactProfileLookUP } from "app/redux/features/contact-profile-lookup";
import { RootState } from "app/store";
import { BadgeCategory } from "app/uicomponents/macrocomponents/MasterDataMilestones/types";
import {
  ApprovalStatus,
  Badges,
  CardFieldsInterface,
  CUSTOM,
  DATEFORMAT,
  INTERACTIVEPROPOSALBRANDINGCOLORS,
  ProposalTypes,
  THEME,
  USERTYPE,
} from "app/utils/types";
import usStates from "data/usStates.json";
import axios from "axios";
import HelloSign from "hellosign-embedded";
import i18n from "i18next";
import { Checkbox } from "primereact/checkbox";
import { Image } from "primereact/image";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import * as R from "ramda";
import { is, isEmpty, mapObjIndexed, pickBy, pipe, trim } from "ramda";
import { Dispatch, KeyboardEvent } from "react";
import { ValidateResult } from "react-hook-form";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import IappLightModeLogo from "../assets/IAPPLogoColor.svg";
import IAPPLogoDarkIcon from "../assets/IAPPLogoDarkIcon.svg";
import IappDarkModeLogo from "../assets/IAPPLogoDarkMode.svg";
import IAppLogoWithText from "../assets/IAppLogoWithText.png";
import buySell from "../assets/svg/bs-img.svg";
import keyPerson from "../assets/svg/kpi-img.svg";
import splitDollar from "../assets/svg/sd-img.svg";
import premiumFinance from "../assets/PlansIcons/PremiumFinance.png";
import { getLocalStore, getObjectFromLocalStore } from "./localStore";
import { formatDate, formatDateFromJSDate, formatDateToSubmit } from "./luxon";
import { getThemedPrimarySecondaryFromSource } from "./brandingTheme";
import { getObjectFromSessionStore, getSessionStore, removeSessionStore } from "./sessionStore";

// UIP Messaging API base URL - use env var or fallback to QA UIP
const NEIO_CORE_API_URL =
  process.env.REACT_APP_NEIO_CORE_API_URL || "https://qa-uip.iapp.cool/api/v1";

export const IAPPLogo = (props: { classAdd?: string }) => {
  const { classAdd } = props;
  const branding = useSelector((state: RootState) => state?.contactBranding);
  const { data: lookupData } = useSelector(contactProfileLookUP);

  const IAPPLogoAWS =
    (branding.primaryLogo === "" || !branding.primaryLogo) &&
    !lookupData?.branding?.hasActiveElitePlan
      ? branding.theme === THEME.DARK
        ? process.env.REACT_APP_ENVIRONMENT === "PROD"
          ? `${process.env.REACT_APP_ASSET_URL_PROD}/iapp_white.png`
          : `${process.env.REACT_APP_ASSET_URL_DEV}/iapp_white.png`
        : process.env.REACT_APP_ENVIRONMENT === "PROD"
        ? `${process.env.REACT_APP_ASSET_URL_PROD}/iapp_color.png`
        : `${process.env.REACT_APP_ASSET_URL_DEV}/iapp_color.png`
      : branding.primaryLogo;

  return (
    <div className={`${classAdd || "absolute flex align-items-center my-2 gap-2 top-0"}`}>
      <div>
        <Image src={IAPPLogoAWS} alt="Image" width="180" />
      </div>
    </div>
  );
};

/**
 * Format a number into a compact string with K, M, B suffixes.
 * Shows decimals only when needed.
 */

export const formatToCompactNumber = (
  value: any,
  { prefix = "", suffix = "", decimals = 2 } = {},
) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return `${prefix}0${suffix}`;
  }

  const num = Number(value);
  const absNum = Math.abs(num);
  let formatted = "";

  if (absNum >= 1_000_000_000_000) {
    formatted = `${(num / 1_000_000_000_000).toFixed(decimals)}T`; // trillion
  } else if (absNum >= 1_000_000_000) {
    formatted = `${(num / 1_000_000_000).toFixed(decimals)}B`; // billion
  } else if (absNum >= 1_000_000) {
    formatted = `${(num / 1_000_000).toFixed(decimals)}M`; // million
  } else if (absNum >= 1_000) {
    formatted = `${(num / 1_000).toFixed(decimals)}K`; // thousand
  } else {
    formatted = num.toFixed(decimals); // number
  }

  // Remove unnecessary trailing zeros after decimal
  formatted = formatted.replace(/\.0+([KMB]?)$/, "$1");

  return `${prefix}${formatted}${suffix}`;
};

export const IAPPDarkLogo = (props: { classAdd?: string }) => {
  const { classAdd } = props;
  return (
    <div className={`flex align-items-center my-2 gap-2 absolute top-0 ${classAdd || "absolute"}`}>
      <div>
        <Image
          src={
            process.env.REACT_APP_ENVIRONMENT === "PROD"
              ? `${process.env.REACT_APP_ASSET_URL_PROD}/iapp_white.png`
              : `${process.env.REACT_APP_ASSET_URL_DEV}/iapp_white.png"`
          }
          alt="Image"
          width="100"
          height="100"
        />
      </div>
    </div>
  );
};

export const FormBody = () => {};

export const validatePassword = (value: any): ValidateResult => {
  const hasLower = /[a-z]/.test(value);
  const hasUpper = /[A-Z]/.test(value);
  const hasNumberValue = /\d/.test(value);
  const hasSpeciaCharacter = /^(?=.*[!@=#$%^&*()_+{}\\[\]:;<>,.?~`'"|\\/\\-])[^\s]+$/.test(value);
  const hasMinimumLength = value.length >= 8;
  const returnObject = JSON.stringify({
    hasLower,
    hasUpper,
    hasSpeciaCharacter,
    hasNumberValue,
    hasMinimumLength,
  });
  return returnObject;
};
export const getFirstNameInitial = (name?: string): string | undefined => {
  if (!name) return undefined;
  const parts = name.split(",");
  const firstName = parts.length > 1 ? parts.slice(1).join(",").trim() : parts[0].trim();
  return firstName.charAt(0).toUpperCase() || undefined;
};

export const convertCamelCaseToSentenceCase = (camelCaseString: any) =>
  camelCaseString
    ?.replace(/([A-Z])/g, " $1")
    ?.replace(/\s+/g, " ")
    ?.replace(/^./, (str: string) => str.toUpperCase())
    ?.trim();

export function convertStringNumberToTwoDecimal(value: any, isCurrency = true, currency = "$") {
  const twoDecimalPointString = isCurrency
    ? `${currency}${Number(value).toFixed()}`
    : Number(value).toFixed(0);

  return twoDecimalPointString;
}

export const toTitleCase = (input: string) => {
  const lowerCaseWords = [
    "of",
    "and",
    "to",
    "in",
    "for",
    "on",
    "by",
    "with",
    "a",
    "an",
    "the",
    "at",
    "as",
    "from",
  ];

  const words = input.split(" ");

  const result = words.map((word, index) => {
    if (index !== 0 && lowerCaseWords.includes(word.toLowerCase())) {
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return result.join(" ");
};

export const capitalizeFirstLetterOfStr = (str: any) => str.charAt(0).toUpperCase() + str.slice(1);

export { getThemedPrimarySecondaryFromSource };

export const getButtonStyleWithBranding = () => {
  const getlookUpResponse = getObjectFromSessionStore("lookUpResponse");
  const branding = getlookUpResponse?.branding;
  const { primaryColor: themedBtnPrimary } = getThemedPrimarySecondaryFromSource(branding, "", "");
  return branding?.hasActiveElitePlan
    ? {
        backgroundColor: themedBtnPrimary,
        borderColor: themedBtnPrimary,
      }
    : {};
};

export const convertDataToFields = (
  data: CardFieldsInterface | any,
  fieldsMapping: { [key: string]: any }[],
) => {
  const fields: {
    id: string;
    label: any;
    value: any;
    itemStyle?: { [key: string]: string };
  }[] = fieldsMapping.map(({ key, label, itemStyle }) => ({
    id: uuidv4(),
    label:
      label || key === "positionTitle"
        ? convertCamelCaseToSentenceCase("title")
        : key === "What interest rate will be used for financing"
        ? "What Interest Rate will be used for Financing?"
        : toTitleCase(
            convertCamelCaseToSentenceCase(
              key === "employerLoanFundingDuration"
                ? "employerFinancingFundingDuration"
                : key === "employeeLoanFundingDuration"
                ? "employeeFundingDuration"
                : key,
            ),
          ),
    value: data[key],
    itemStyle,
  }));
  return fields;
};

export const capitalizeWords = R.pipe(
  R.split(" "), // Split the string into words
  R.map(capitalizeFirstLetterOfStr), // Convert each word to uppercase
  R.join(" "), // Join the words back into a string
);

export function prettifyData(data: any[]) {
  const isStringEmpty = pipe(trim, isEmpty);
  const prettyData = data?.map((item: any) => ({
    ...item,
    contactName: isStringEmpty(item.contactName) ? "-" : item.contactName,
    email: isEmpty(item?.email) ? "-" : item?.email,
  }));
  return prettyData;
}

export function prettifyDataForLoans(data: any[]) {
  const isStringEmpty = pipe(trim, isEmpty);
  const prettyData = data?.map((item: any) => ({
    ...item,
    loanContactName: isStringEmpty(item.loanContactName) ? "-" : item.loanContactName,
  }));
  return prettyData;
}

export const MAX_ENTITY_WORDS = 25;
export const MAX_ENTITY_WORD_LENGTH = 25;

export const truncateEntityForDisplay = (
  fullValue: string,
): {
  display: string;
  full: string;
} => {
  const full = String(fullValue ?? "").trim();
  if (!full || full === "—" || full === "-") return { display: "—", full };

  const words = full.split(/\s+/).filter(Boolean);
  const needsWordCountTruncation = words.length > MAX_ENTITY_WORDS;

  const limitedWords = words.slice(0, MAX_ENTITY_WORDS).map((w) => {
    if (w.length <= MAX_ENTITY_WORD_LENGTH) return w;
    return `${w.slice(0, MAX_ENTITY_WORD_LENGTH)}...`;
  });

  const needsWordLengthTruncation = words.some((w) => w.length > MAX_ENTITY_WORD_LENGTH);
  const needsTruncation = needsWordCountTruncation || needsWordLengthTruncation;

  if (!needsTruncation) return { display: full, full };

  const displayBase = limitedWords.join(" ");
  return {
    display: needsWordCountTruncation ? `${displayBase}...` : displayBase,
    full,
  };
};

export const capitalizeFirstLetter = (string?: string) =>
  `${string?.charAt(0).toUpperCase()}${string?.slice(1)}`;

export type StatusBadgeStatus = "active" | "inactive" | "completed" | "activeBlue";

export interface StatusLabelAndValue {
  label: string;
  status: StatusBadgeStatus;
}

/**
 * Maps a raw status string (e.g. from API) to display label and StatusBadge status.
 * Returns null if the value is not one of active, inactive, or completed.
 */
export function getStatusLabelAndValue(
  rawStatus: string | undefined | null,
): StatusLabelAndValue | null {
  const normalized = rawStatus?.toLowerCase();
  if (normalized === "active") return { label: "Active", status: "activeBlue" };
  if (normalized === "completed") return { label: "Completed", status: "active" };
  if (normalized === "inactive") return { label: "Inactive", status: "inactive" };
  return null;
}

export const formatUnits = (loanBalance: number, currency?: any) => {
  const loanBalanceData = typeof loanBalance === "string" ? Number(loanBalance) : loanBalance;
  const balance = loanBalanceData || 0;
  const roundedValue = balance?.toFixed(0);
  const formattedBalance = Number(roundedValue)?.toLocaleString();
  return currency === "$" ? `$${formattedBalance}` : formattedBalance;
};

export const getFieldFromObject = (object: any, field: any) =>
  field.split(".").reduce((obj: any, key: any) => obj?.[key], object);

export const combinedString = (messages: string[] | string) =>
  Array.isArray(messages) ? messages.map((message: any) => `${message}. `).join("\n") : messages;

export const feetToInches = (feet: number, inches: number) => feet * 12 + inches;

export const feetToCentimeters = (feet: number, inches: number) => {
  const centimeters = feet * 30.48 + inches * 2.54;
  return centimeters;
};

export const cmsToFeet = (cms: string | number) => {
  const centimeters = Number(cms);
  const inches = centimeters * 0.393701;
  const feet = Math.floor(inches / 12);
  const remainingInches = Math.round(inches % 12);
  const heightInFeet = `${feet}'${remainingInches}"`;
  return heightInFeet;
};

export function centimetersToFeetAndInches(centimeters: any) {
  // Convert centimeters to inches
  const cmToInches = centimeters * 0.393701;

  // Convert inches to feet and remaining inches
  const feet = Math.floor(cmToInches / 12);
  const inches = Math.round(cmToInches % 12);

  return { feet, inches };
}

export const extractFilters = (data: any) => {
  const filters: any = {};
  // Loop through each column
  // eslint-disable-next-line no-restricted-syntax
  for (const column of data.column) {
    const { field, filters: columnFilters } = column;

    // Check if the column has filters
    if (columnFilters) {
      const { value } = columnFilters;

      // Add the filter value to the filters object
      if (value !== undefined && value !== "") {
        filters[field as string] = value;
      }
    }
  }

  return filters;
};

export const getSubscriptionTypeFilterMenu = () => [
  { label: "Starter", value: "starter" },
  { label: "Premium", value: "premium" },
  { label: "Elite", value: "elite" },
];

export const debounce = (callback: any, delay: number) => {
  let timeoutId: any;

  return (...args: any[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};
export function objectToQueryString(obj: any) {
  const queryParts = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const value = Array.isArray(obj[key][0])
        ? encodeURIComponent(JSON.stringify(obj[key][0]))
        : typeof obj[key][0] === "number"
        ? obj[key]
        : encodeURIComponent(obj[key]); // 2023-05-23,2023-05-30
      if (value && Array.isArray(obj[key][0]) && obj[key][0].length) {
        queryParts.push(`${key}=${value}`);
      } else if (value && !Array.isArray(obj[key][0])) {
        // incase on integer array
        is(Number, obj[key][0])
          ? queryParts.push(`${key}=[${value}]`)
          : queryParts.push(`${key}=["${value.toLowerCase()}"]`);
      }
    }
  }
  return queryParts.join("&");
}

export function objectToQueryStringWithLowerCase(obj: any) {
  const queryParts = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const value = Array.isArray(obj[key][0])
        ? encodeURIComponent(JSON.stringify(obj[key][0]))
        : typeof obj[key][0] === "number"
        ? obj[key]
        : encodeURIComponent(obj[key]); // 2023-05-23,2023-05-30
      if (value && Array.isArray(obj[key][0]) && obj[key][0].length) {
        queryParts.push(`${key}=${value}`);
      } else if (value && !Array.isArray(obj[key][0])) {
        // incase on integer array
        is(Number, obj[key][0])
          ? queryParts.push(`${key}=[${value}]`)
          : queryParts.push(`${key}=["${value}"]`);
      }
    }
  }
  return queryParts.join("&");
}

export const updateFiltersValue = (items: any, field: any, value: string | number) =>
  items.map((item: any) => {
    if (item.field === field) {
      return {
        ...item,
        filters: {
          ...item.filters,
          value,
        },
      };
    }
    return item;
  });

export const resetFiltersValue = (items: any) =>
  items.map((item: any) => ({
    ...item,
    filters: {
      ...item.filters,
      value: "",
    },
  }));

export const convertFilters = (filters: any, propName: any) =>
  mapObjIndexed((val: any[]) => [val[propName]], filters);

export const truncateString = (str: any, maxLength: any) => `${str.slice(0, maxLength)}...`;
export const truncateChars = (str?: string | null, maxLength = 20): string => {
  if (!str) return "";
  return str.length > maxLength ? `${str.slice(0, maxLength)}…` : str;
};
export const removeEmptyKeys = (obj: any): object => pickBy((value) => !isEmpty(value), obj);

export function capitalizeNames(inputString: any) {
  function capitalizeFirstLetterOfArray(name: any) {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }
  const namesArray = inputString?.split(",");
  const capitalizedNamesArray = namesArray?.map((name: any) =>
    capitalizeFirstLetterOfArray(name.trim()),
  );
  const capitalizedNamesString = capitalizedNamesArray?.join(", ");

  return capitalizedNamesString;
}

export const getFirstNameAbbreviation = (name: string) => {
  const words = name.trim().split(" ");

  const abbreviation = words
    .filter((word: string) => word.length > 0)
    .map((word: string) => word[0].toUpperCase())
    .join("");

  return abbreviation;
};

export const POLICY_SUB_TYPE_ABBREVIATIONS: Record<string, string> = {
  "Guaranteed Universal Life": "GUL",
  "Indexed Universal Life": "IUL",
  "Variable Universal Life": "VUL",
  "Universal Life": "UL",
  "Whole Life": "WL",
  Term: "T",
  "Buy Out": "BO",
  Other: "Oth",
};

/** Short code for a policy sub-type, e.g. "Indexed Universal Life" → "IUL". */
export const getPolicySubTypeAbbreviation = (subType?: string): string => {
  const value = subType ?? "";
  return POLICY_SUB_TYPE_ABBREVIATIONS[value] ?? (value.slice(0, 3) || "-");
};

export const truncateEmailBeforeAtSymbol = (email: string) => {
  if (!email || typeof email !== "string") {
    return "";
  }

  const atIndex = email.indexOf("@");
  if (atIndex === -1 || atIndex <= 16) {
    return email;
  }

  return `${email.slice(0, 16)}...${email.slice(atIndex)}`;
};

export const getEncodedURI = (obj: any) => {
  const filterAgentsClone = { ...obj };
  if ("team" in filterAgentsClone && !isEmpty(filterAgentsClone.team[0])) {
    filterAgentsClone.team = filterAgentsClone.team.map((item: any) => Number(item));
  }
  if ("invitationDate" in filterAgentsClone && !isEmpty(filterAgentsClone.invitationDate[0])) {
    const dateVal = filterAgentsClone.invitationDate[0];
    const formattedFilterProposal = dateVal
      ? [...dateVal.map((item: string) => formatDateFromJSDate(item, "yyyy-MM-dd"))]
      : [];
    filterAgentsClone.invitationDate[0] = formattedFilterProposal;
  }
  return objectToQueryString(filterAgentsClone);
};

export const checkForAnySearchParameter = (obj: any) =>
  Object.keys(obj).reduce(
    (acc, key) => acc || obj[key].some((agent: string) => agent?.trim().length > 0),
    false,
  );

export const openHelloSignModal = (
  url: string,
  onError: () => void,
  onSign: () => void,
  onClose?: () => void,
) => {
  const client = new HelloSign();
  const getLookUpResponse = getObjectFromSessionStore("lookUpResponse");
  // const CLIENT_ID = process.env.HELLO_SIGN_CLIENT_KEY;
  const CLIENT_ID = getLookUpResponse.helloSignClientKey;
  if (!CLIENT_ID && onError) {
    onError();
  }
  if (CLIENT_ID) {
    client.open(url, {
      clientId: CLIENT_ID,
      skipDomainVerification: true,
    });
  }
  if (onSign) {
    client.on("sign", onSign);
  }
  if (onClose) {
    client.on("close", onClose);
  }
};

// export const getOrdinal = (day) => {
//   const lastDigit = day % 10;
//   return lastDigit === 1 ? "st" : lastDigit === 2 ? "nd" : lastDigit === 3 ? "rd" : "th";
// };
export const resetCreateProposalStates = (dispatch: Dispatch<AnyAction>) => {
  removeSessionStore("fromRequestForProposal");
  removeSessionStore("proposalID");
  removeSessionStore("CompanyNameforUpload");
  removeSessionStore("prouctNameforUpload");
  dispatch(resetpostCSVDataState());
  dispatch(resetPlanAdminSplitDollarState());
  dispatch(resetPlanSplitDollarState());
  dispatch(resetgetLoanPlanProjectionState());
};

export const capitalizeFirstLetterOfEveryWordInaString = (sentence: string) =>
  sentence?.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());

export const formatFormData = ({
  formData,
  formDataFormat,
}: {
  formData: any;
  formDataFormat: any[];
}) => {
  if (!formData || !formDataFormat) return [];
  return formDataFormat
    .map((items: any) => {
      const cardApi: any = formData[items.cardType];
      if (Array.isArray(cardApi)) {
        return cardApi.map((api, i: number) => {
          const keysArray = Object.entries(api).map(([key]) => ({ key }));
          const header = {
            ...items.header,
          };
          if (header && cardApi.length > 1) {
            header.value = `${header.value} ${i + 1}`;
          }
          if (typeof header.label === "function") {
            header.label = header.label(cardApi.length > 1 ? i + 1 : "");
          }

          return {
            ...items,
            header,
            fields: convertDataToFields(api, keysArray),
          };
        });
      }
      const keysArray = Object.entries(cardApi).map(([key]) => ({
        key,
        itemStyle: items?.itemStyle,
      }));
      return {
        ...items,
        fields: convertDataToFields(cardApi, keysArray),
      };
    })
    .flat();
};

export const convertCommaSeparated = (data: any) => {
  const fixingData: any = Number(data).toFixed();
  return data ? `$${Number(fixingData).toLocaleString()}` : `$0`;
};

export const convertCommaSeparatedWODollar = (data: any) => {
  const fixingData: any = Number(data).toFixed();
  return data ? `${Number(fixingData).toLocaleString()}` : `0`;
};

export const formatBuySellDetails = (bsData: any, proposalType: ProposalTypes) => {
  if (!bsData) return {};
  const {
    id,
    basicDetails: { entityName, state },
    planDetails: {
      businessValuation,
      currentBuySellAgreement,
      estimatedLastDate,
      fullyFundedOnDeath,
      fullyFundedOnDisability,
      lifeInsuranceType,
      annualRenewableTerm,
      meetEstimatedValuation,
      needBusinessValuation,
      note,
      updateBuySellAgreement,
    },
    shareholders,
  } = bsData;

  const formattedData = {
    id,
    basicDetails: {
      "Proposal type": proposalType,
      "Legal Name of Entity": entityName,
      state,
      "Number of Shareholders": shareholders?.length,
    },
    planDetails: {
      "Estimated Business Valuation": businessValuation
        ? convertCommaSeparated(businessValuation)
        : businessValuation,
      "Estimated date of previous business valuation": estimatedLastDate
        ? formatDate(estimatedLastDate, DATEFORMAT.TYPE3)
        : estimatedLastDate,
      "Need to Complete a Business Valuation?": needBusinessValuation,
      "Buy Sell Agreement in place": currentBuySellAgreement,
      "Wanting to Update the Buy Sell Agreement?": updateBuySellAgreement,
      "Funding in the event of death?":
        Number(fullyFundedOnDeath) === 100 ? "Full" : `${fullyFundedOnDeath}%`,
      "Want Enough Life Insurance to Meet Estimated Valuation in 5 Years?": meetEstimatedValuation,
      "Life Insurance Utilization": lifeInsuranceType,
      ...(annualRenewableTerm &&
        lifeInsuranceType !== "Permanent" &&
        Object.keys(annualRenewableTerm).length > 0 && {
          "Term Length": annualRenewableTerm,
        }),
      "Funding in the event of disability?":
        fullyFundedOnDisability !== "No" ? `${fullyFundedOnDisability}` : "No",
      note,
    },
    shareholders: shareholders?.map((shareholderObj: any) => {
      const {
        name,
        ownershipPercentage,
        dob,
        gender,
        nicotineTobaccoUsage,
        occupation,
        participateInActivities,
      } = shareholderObj;
      return {
        "Shareholder Name": name,
        "Date of Birth": formatDate(dob, DATEFORMAT.TYPE3),
        Gender: gender,
        Ownership: `${ownershipPercentage}%`,
        "Nicotine or Tobacco Usage": nicotineTobaccoUsage,
        Occupation: capitalizeFirstLetter(occupation),
        "Participate In Activities": participateInActivities.join(", "),
      };
    }),
  };

  return formattedData;
};

export const getUSANumberFormat = (
  number: number | string | bigint,
  isDecimal = true,
  isRoundOff = false,
) => {
  if (number || number === 0) {
    if (typeof number === "bigint") {
      return number.toLocaleString("en-US");
    }
    // Strip commas from pre-formatted strings before converting
    const cleaned = typeof number === "string" ? number.replace(/,/g, "") : number;
    const num = Number(cleaned);
    if (Number.isNaN(num)) return "0";
    if (isRoundOff) {
      return Math.round(num).toLocaleString("en-US");
    }
    if (!isDecimal) {
      return Math.floor(num).toLocaleString("en-US");
    }
    return num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  return "0";
};

export const formatKeyPersonDetails = (bsData: any, proposalType: ProposalTypes) => {
  if (!bsData) return {};
  const {
    basicDetails: { entityName, city, state, primaryContact, country, zipCode },
    planDetails: { note },
    kpiEmployees,
  } = bsData;

  const formattedData = {
    basicDetails: {
      "Proposal type": proposalType,
      "Primary Contact": primaryContact,
      "Legal Name of Entity": entityName,
      country,
      state,
      city,
      "Zip Code": zipCode,
      "No. of Employees": kpiEmployees.length,
    },
    planDetails: {
      Employee: kpiEmployees.map((el: any) => (
        <p>
          {el?.name?.lastName}, {el?.name?.firstName}
        </p>
      )),
      "Should this plan utilize permanent or term life insurance?": kpiEmployees.map(
        (employeeObj: any) => (
          <div className="flex items-center my-[0.5rem]">
            <label className="w-1/4 font-normal">
              <Checkbox
                disabled
                checked={employeeObj?.funding?.planUtilize?.permanent}
                className="mr-2"
              />
              Permanent
            </label>
            <label className="w-1/4 font-normal text-center">
              <Checkbox
                disabled
                checked={!!employeeObj?.funding?.planUtilize?.term}
                className="mr-2"
              />
              Term
            </label>
            <InputText
              className={`w-1/4 bg-[var(--gray-300)] ${
                employeeObj?.funding?.planUtilize?.term ? "" : "invisible"
              }`}
              disabled
              value={`${employeeObj?.funding?.planUtilize?.term} Years`}
            />
          </div>
        ),
      ),
      "Should the plan provide protection in the event of disability?": kpiEmployees.map(
        (employeeObj: any) => (
          <div className="flex items-center">
            <label className="w-1/4 font-normal">
              <RadioButton
                disabled
                checked={employeeObj?.funding?.planProtection}
                className="mr-2 cursor-default"
              />
              Yes
            </label>
            <label className="w-1/4 font-normal">
              <RadioButton
                disabled
                checked={!employeeObj?.funding?.planProtection}
                className="mr-2 cursor-default"
              />
              No
            </label>
            <InputNumber className="invisible w-1/4" inputClassName="w-full" disabled />
          </div>
        ),
      ),
      "Additional Remarks:": note,
    },
    kpiEmployees: kpiEmployees.map((employeeObj: any) => {
      const {
        name,
        annualSalary,
        valuationMethod,
        valuation,
        dob,
        gender,
        email,
        nicotineTobaccoUsage,
        occupation,
        participateInActivities,
      } = employeeObj;
      return {
        "Employee Name": `${name?.lastName ?? ""}, ${name?.firstName ?? ""}`,
        "Annual Salary": `$${getUSANumberFormat(annualSalary)}`,
        "Valuation Method": valuationMethod,
        "Value of Key Person": `$${getUSANumberFormat(valuation)}`,
        "Date of Birth": formatDate(dob, DATEFORMAT.TYPE3),
        Gender: gender,
        Email: email,
        "Nicotine or Tobacco Usage": nicotineTobaccoUsage,
        Occupation: capitalizeFirstLetter(occupation),
        Activities: participateInActivities.join(", "),
      };
    }),
  };

  return formattedData;
};

export const getProvisionDataToPost = (data: any, proposalId: string) => {
  if (isEmpty(data)) return [];
  const formattedData = Object.entries(data).reduce((acc: any, curr: any) => {
    const [key, val = ""] = curr;
    if (val && !isEmpty(val) && typeof val === "object") {
      const { payout, condition } = val;
      const formattedPayout = payout === CUSTOM ? data[`${key}percentage`] : payout;
      const formattedCondition = payout === CUSTOM ? data[`${key}condition`] : condition;
      acc.push({
        name: capitalizeFirstLetter(key),
        payout: Number(formattedPayout),
        condition: formattedCondition,
        proposalId,
      });
    }
    return acc;
  }, []);
  return {
    provisions: formattedData,
  };
};

export const transformString = (inputString: string, separator: string = " "): string => {
  const separatedWords = inputString.split(/(?=[A-Z])/);
  return separatedWords
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(separator);
};

export const toCamelCase = (str: string): string =>
  str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());

// add userType specific proposal statuses
export const proposalStatusByUserType = {
  admin: {
    signed: "Awaiting IAPP Approval",
    uploaded: "Awaiting IAPP Approval",
    received: "Review & Sign",
    feedback: "Awaiting Updated Proposal",
    requested: "Proposal Requested",
    draft: "Proposal Requested",
    created: "Proposal Requested",
  },
  agent: {
    signed: "Awaiting IAPP Approval",
    uploaded: "Awaiting IAPP Approval",
    received: "Review & Sign",
    feedback: "Awaiting Updated Proposal",
    requested: "Proposal Requested",
    draft: "Proposal Requested",
    created: "Proposal Requested",
  },
  contact: {
    signed: "Awaiting IAPP Approval",
    uploaded: "Awaiting IAPP Approval",
    sent: "Review & Sign",
    feedback: "Awaiting Updated Proposal",
    requested: "Awaiting Proposal",
    draft: "Awaiting Proposal",
    received: "Awaiting Advisor Approval",
    created: "Draft Created",
    new_signature_requested: "New Signatures Needed",
  },
};

export const proposalStatus: Record<string, string> = {
  requested: "Proposal Requested",
  revoked: "Proposal Revoked",
  draft: "Initial Draft",
  created: "Draft Created",
  received: "Awaiting Advisor Approval",
  sent: "Awaiting Client Approval",
  downloaded: "Advisor Downloaded Proposal",
  feedback: "Change Request",
  reviewed: "Advisor Reviewed Proposal",
  signed: "Finalize Proposal",
  uploaded: "Finalize Proposal",
  new_signature_requested: "New Signatures Needed",
  approved: "Approved",
  inactive: "Inactive",
  pending_drafts: "Pending Draft",
  pending_revoked: "Pending Revoked",
  pending_review: "Pending Review",
  pending_approve: "Pending Approve",
  pending_InProgress: "Pending In Progress",
  pending_inactive: "Pending Inactive",
  plan_created: "Plan Created",
};

export const proposalStatuses = (): Record<string, string> => ({
  ...proposalStatus,
  ...(proposalStatusByUserType[
    getObjectFromLocalStore("useraccess")?.userType as keyof typeof proposalStatusByUserType
  ] ?? {}),
});

function pad(number: any) {
  return (number < 10 ? "0" : "") + number;
}

export function getTime(timestampString: any) {
  const date = new Date(timestampString);

  // Get the UTC components
  const utcHours = date.getUTCHours();
  const utcMinutes = date.getUTCMinutes();

  // Format the time in 24-hour and minute format
  const timeString = `${pad(utcHours)}:${pad(utcMinutes)}`;
  return timeString;
}

export function ValidatePhoneNumber(value: any) {
  const lastTenDigits = String(value).substring(value.length - 10);
  if (lastTenDigits === "" || lastTenDigits.trim() === "+") return i18n.t("general.phoneRequired");
  if (!/^\d+$/.test(lastTenDigits)) return i18n.t("general.phoneValidation.message");
  return true;
}

export const getAccessForPermission = (
  resourceName: any,
  accessType: "readAccess" | "writeAccess" = "writeAccess",
) => {
  const superAdminUser = getLocalStore("useraccess");
  if (superAdminUser?.isSuperAdmin) return false;
  const getlookUpResponse = getObjectFromSessionStore("lookUpResponse");
  const roleData = getlookUpResponse?.permissionData
    ?.find((item: any) => item.roleName === getlookUpResponse?.role?.roleName)
    ?.permissions?.find((permissions: any) => permissions?.resource?.name === resourceName);

  if (roleData) {
    return !roleData[accessType];
  }
  return false;
};

export const getAccessForPermissionV2 = (
  resourceName: any,
  accessType: "readAccess" | "writeAccess" = "writeAccess",
) => {
  const getlookUpResponse = getObjectFromSessionStore("lookUpResponse");
  const currentRoleName =
    getlookUpResponse?.role?.roleName ??
    getlookUpResponse?.roleName ??
    getlookUpResponse?.role?.name ??
    getlookUpResponse?.role;

  const rolePermissions =
    (currentRoleName
      ? getlookUpResponse?.permissionData?.find((item: any) => item?.roleName === currentRoleName)
      : getlookUpResponse?.permissionData?.[0]
    )?.permissions ?? [];

  const roleData = rolePermissions.find(
    (permission: any) => permission?.resource?.name === resourceName,
  );

  if (roleData) {
    return !roleData[accessType];
  }
  return false;
};

export const getFileName = (path: string) => {
  if (!path) return "";

  // Strip query parameters and decode URI components
  const [rawPath] = path.split("?");
  let sanitizedPath = rawPath;
  try {
    sanitizedPath = decodeURIComponent(rawPath);
  } catch {
    sanitizedPath = rawPath;
  }

  // Extract just the filename
  const idx = sanitizedPath.lastIndexOf("/");
  let fileName = idx !== -1 ? sanitizedPath.substring(idx + 1) : sanitizedPath;

  // Remove only timestamp-like suffixes (e.g., _123456789) before the extension, if present
  fileName = fileName.replace(/(.*?)(?:_(\d+))(\.[^.]+)$/u, "$1$3");

  return fileName;
};

export function convertToCSV(objArray: any) {
  const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  let str = "";

  // Add headers

  const headers = Object.keys(array[0]);
  // eslint-disable-next-line
  str += headers.join(",") + "\r\n";

  // Add data
  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (let j = 0; j < headers.length; j++) {
      if (line !== "") line += ",";

      // line += array[i][headers[j]];
      line += `"${array[i][headers[j]]}"`;
    }
    // eslint-disable-next-line
    str += line + "\r\n";
  }

  return str;
}

export function downloadCSV(data: any, filename: any) {
  const csv = convertToCSV(data);

  const blob = new Blob([csv], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export const CHAT_API_URL = "https://zealert-api.westus2.cloudapp.azure.com/core/v1";

export const getChatConversation = (currUserId: string, receiverUserId: string) =>
  axios.post(`${CHAT_API_URL}/workspace/conversation`, {
    conversation: {
      title: "",
      created_by: currUserId,
    },
    participants: [
      {
        participant_id: currUserId,
      },
      {
        participant_id: receiverUserId,
      },
    ],
  });

export const sendMessage = (
  conversationId: number,
  currUserId: string,
  message?: string,
  files?: any[],
) =>
  axios.post(`${CHAT_API_URL}/messages`, {
    conversation_id: conversationId,
    sender: currUserId,
    message: message ?? "",
    data: {
      files: files ?? [],
    },
  });

/**
 * Send a message to a conversation via UIP API.
 * Uses POST /messaging/conversations/{id}/messages endpoint.
 */
export const sendMessageForHive = (
  conversationId: number | string,
  currUserId: string,
  message?: string,
  files?: any[],
  currUserType: string = "user",
) => {
  const workspaceId = getObjectFromLocalStore("uipWorkspaceId");
  const uipToken = getObjectFromLocalStore("uipAccessToken");

  if (!workspaceId) {
    return Promise.reject(new Error("Workspace ID not configured"));
  }

  // UIP uses /messaging/conversations/{id}/messages
  return axios.post(
    `${NEIO_CORE_API_URL}/messaging/conversations/${conversationId}/messages`,
    {
      content: message ?? "",
      content_type: files && files.length > 0 ? "mixed" : "text",
      caller_user_id: currUserId,
      caller_user_type: currUserType,
      metadata: files && files.length > 0 ? { files } : {},
    },
    {
      headers: {
        "X-API-Key": String(uipToken || ""),
      },
    },
  );
};

export const calculateAge = (birthday: any) => {
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const getAgeBasedOnSixMonths = (birthday: any) => {
  const today = new Date();
  const birthDate = new Date(birthday);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // If birthday hasn't occurred this year, subtract 1
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  // If months are more than 6, add one year
  if (monthDiff > 6 || (monthDiff === 6 && today.getDate() >= birthDate.getDate())) {
    age++;
  }

  return age;
};

export const WAIVE_OFF_DAY_COUNT = 0; // set to 4 once qa testing is done

export function formatPhoneNumber(phoneNumberString: string) {
  if (phoneNumberString === "NA" || Boolean(phoneNumberString) === false) {
    return "NA";
  }
  const cleaned = `${phoneNumberString}`.replace(/\D/g, "");
  const match = cleaned.match(/^(?:\d{1,2})?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const countryCode = cleaned.slice(0, -10) || "1";
    const formattedNumber = `+${countryCode} (${match[1]}) ${match[2]}-${match[3]}`;
    return formattedNumber;
  }
  return null;
}

export function invertObject(obj: { [key: string]: string }): { [key: string]: string | string[] } {
  const newObj: { [key: string]: string | string[] } = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key] in newObj) {
      const prevVal = Array.isArray(newObj[obj[key]]) ? newObj[obj[key]] : [newObj[obj[key]]];
      newObj[obj[key]] = [...(prevVal as string[]), key];
    } else {
      newObj[obj[key]] = key;
    }
  });

  return newObj;
}

export function checkObjForZeroValues(data: any, keysToCheck: any[] = []) {
  if (data === undefined) {
    return false;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key of keysToCheck) {
    if (Number(data[key]) === 0) {
      return false;
    }
  }

  return true;
}

export const getBlobUrl = (url: string) => {
  const uri = url?.split(",");
  if (!uri || uri?.length < 2) {
    return url;
  }
  const byteCharacters = atob(uri[1]);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: "application/pdf" });

  return URL.createObjectURL(blob);
};

export function HeaderSvgBgSring(bgColor = "#85B2F9") {
  const svgString = `<svg width="1440" height="180" viewBox="0 0 1440 180" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame 811498" clip-path="url(#clip0_254_234)">
<rect width="1440" height="180" fill="${bgColor}"/>
<g id="Group 811497">
<g id="Mask group">
<mask id="mask0_254_234" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1440" height="256">
<rect id="Image" width="1440" height="256" fill="#F1F1F1"/>
</mask>
<g mask="url(#mask0_254_234)">
<g id="Group 1832">
<g id="Ellipse 18" filter="url(#filter0_d_254_234)">
<circle cx="730.963" cy="730.963" r="730.963" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 1334.6 303.812)" fill="url(#paint0_linear_254_234)" shape-rendering="crispEdges"/>
<circle cx="730.963" cy="730.963" r="730.588" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 1334.6 303.812)" stroke="url(#paint1_linear_254_234)" stroke-width="0.75" shape-rendering="crispEdges"/>
</g>
<g id="Ellipse 21" filter="url(#filter1_d_254_234)">
<circle cx="971.646" cy="971.646" r="971.646" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 1669 303.812)" fill="url(#paint2_linear_254_234)" shape-rendering="crispEdges"/>
<circle cx="971.646" cy="971.646" r="971.271" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 1669 303.812)" stroke="url(#paint3_linear_254_234)" stroke-width="0.75" shape-rendering="crispEdges"/>
</g>
<g id="Ellipse 19" filter="url(#filter2_d_254_234)">
<circle cx="476.715" cy="476.715" r="476.715" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 981.344 303.813)" fill="url(#paint4_linear_254_234)" shape-rendering="crispEdges"/>
<circle cx="476.715" cy="476.715" r="476.34" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 981.344 303.813)" stroke="url(#paint5_linear_254_234)" stroke-width="0.75" shape-rendering="crispEdges"/>
</g>
<g id="Ellipse 20" opacity="0.5" filter="url(#filter3_d_254_234)">
<circle cx="233.061" cy="233.061" r="233.061" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 642.812 303.813)" fill="url(#paint6_linear_254_234)" shape-rendering="crispEdges"/>
<circle cx="233.061" cy="233.061" r="232.686" transform="matrix(-0.694698 0.719302 -0.694698 -0.719302 642.812 303.813)" stroke="url(#paint7_linear_254_234)" stroke-width="0.75" shape-rendering="crispEdges"/>
</g>
</g>
</g>
</g>
</g>
</g>
<defs>
<filter id="filter0_d_254_234" x="-413.135" y="-450.757" width="1464.27" height="1515.14" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="3"/>
<feGaussianBlur stdDeviation="7"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0.03 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_254_234"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_254_234" result="shape"/>
</filter>
<filter id="filter1_d_254_234" x="-649.594" y="-695.591" width="1937.19" height="2004.81" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="3"/>
<feGaussianBlur stdDeviation="7"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0.03 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_254_234"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_254_234" result="shape"/>
</filter>
<filter id="filter2_d_254_234" x="-163.35" y="-192.123" width="964.698" height="997.873" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="3"/>
<feGaussianBlur stdDeviation="7"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0.03 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_254_234"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_254_234" result="shape"/>
</filter>
<filter id="filter3_d_254_234" x="76.0277" y="55.733" width="485.941" height="502.16" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="3"/>
<feGaussianBlur stdDeviation="7"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0.03 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_254_234"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_254_234" result="shape"/>
</filter>
<linearGradient id="paint0_linear_254_234" x1="730.963" y1="-119.179" x2="730.963" y2="677.179" gradientUnits="userSpaceOnUse">
<stop offset="0.00508045" stop-color="white"/>
<stop offset="1" stop-color="#F5F5F5" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint1_linear_254_234" x1="752.812" y1="-15.8905" x2="709.113" y2="959.388" gradientUnits="userSpaceOnUse">
<stop stop-color="#ECECEC"/>
<stop offset="1" stop-color="#F9F9F9"/>
</linearGradient>
<linearGradient id="paint2_linear_254_234" x1="971.646" y1="-158.42" x2="971.646" y2="900.153" gradientUnits="userSpaceOnUse">
<stop offset="0.00508045" stop-color="white"/>
<stop offset="1" stop-color="#F5F5F5" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint3_linear_254_234" x1="1000.69" y1="-21.1227" x2="942.602" y2="1275.28" gradientUnits="userSpaceOnUse">
<stop stop-color="#ECECEC"/>
<stop offset="1" stop-color="#F9F9F9"/>
</linearGradient>
<linearGradient id="paint4_linear_254_234" x1="476.715" y1="-77.7252" x2="476.715" y2="441.639" gradientUnits="userSpaceOnUse">
<stop offset="0.00508045" stop-color="white"/>
<stop offset="1" stop-color="#F5F5F5" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint5_linear_254_234" x1="490.964" y1="-10.3634" x2="462.465" y2="625.688" gradientUnits="userSpaceOnUse">
<stop stop-color="#ECECEC"/>
<stop offset="1" stop-color="#F9F9F9"/>
</linearGradient>
<linearGradient id="paint6_linear_254_234" x1="233.061" y1="-37.999" x2="233.061" y2="215.912" gradientUnits="userSpaceOnUse">
<stop offset="0.00508045" stop-color="white"/>
<stop offset="1" stop-color="#F5F5F5" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint7_linear_254_234" x1="240.027" y1="-5.06653" x2="233.061" y2="256.762" gradientUnits="userSpaceOnUse">
<stop stop-color="#D5D5D5"/>
<stop offset="1" stop-color="#F9F9F9"/>
</linearGradient>
<clipPath id="clip0_254_234">
<rect width="1440" height="180" fill="white"/>
</clipPath>
</defs>
</svg>
`;

  return svgString;
}

export function updatePanelItems(items: any, response: any) {
  const hidePending = response.pendingApproved === 0;
  const hideProposals = response.proposals === 0;
  const updatedItems = items.map((item: any) => ({
    ...item,
    hide: item.name === "Pending" ? hidePending : item.name === "Proposals" ? hideProposals : false,
  }));

  return updatedItems;
}

export function hexToRgb(hex: string) {
  // Remove the hash (#) if it's included
  hex = hex.replace(/^#/, "");

  // Parse the hex value into red, green, and blue components
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255; // Extract the red component
  const g = (bigint >> 8) & 255; // Extract the green component
  const b = bigint & 255; // Extract the blue component

  return `${r}, ${g}, ${b}`; // Return as a string
}

export const getTextColorBasedOnBG = (color: string) => {
  // Convert color to RGB
  const rgb = parseInt(color.slice(1), 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return black for light colors, white for dark colors
  return luminance > 0.5 ? "#000000" : "#ffffff";
};

export const isBgDark = (color: string) => getTextColorBasedOnBG(color) === "#ffffff";

export const isDarkTheme = () => {
  const globalTheme = getSessionStore("globalTheme");
  return globalTheme === THEME.DARK;
};

interface SafariWindow extends Window {
  safari?: {
    pushNotification: any;
  };
}

export const isSafari = () =>
  typeof (window as SafariWindow).safari === "object" &&
  (window as SafariWindow).safari?.pushNotification;

export const copyAndPaste = (
  e: KeyboardEvent<HTMLInputElement>,
  callback: (valueToPaste: string) => void,
) => {
  if ((e.metaKey || e.ctrlKey) && e.key === "c") {
    const input = e.target as HTMLInputElement;
    const selectedText = input.value.substring(input.selectionStart || 0, input.selectionEnd || 0);

    navigator.clipboard.writeText(selectedText);
  } else if ((e.metaKey || e.ctrlKey) && e.key === "v") {
    // Read from clipboard and paste
    navigator.clipboard.readText().then((pastedText) => {
      const input = e.target as HTMLInputElement;
      const currentValue = input.value;
      const selectionStart = input.selectionStart || 0;
      const selectionEnd = input.selectionEnd || 0;

      let newValue;

      if (selectionStart !== selectionEnd) {
        // Replace selected text
        newValue =
          currentValue.substring(0, selectionStart) +
          pastedText +
          currentValue.substring(selectionEnd);
      } else {
        // Insert at cursor position
        newValue =
          currentValue.substring(0, selectionStart) +
          pastedText +
          currentValue.substring(selectionStart);
      }
      callback(newValue);
    });

    e.preventDefault(); // Prevent default paste behavior
  }
};

export const positionCalenderLayout = (
  inputClassName: string,
  overlayPanelClassName: string,
  showOnBottom = false,
  calendarLeftAlign = false,
  isCalenderInsideOverlay = false, // true - if the calender input is inside another popup or dialog
) => {
  const calenderOverlay = document.getElementsByClassName(
    overlayPanelClassName,
  )?.[0] as HTMLDivElement;

  const calenderInput = document.getElementsByClassName(inputClassName)?.[0] as HTMLInputElement;

  const calenderOverlayRect = calenderOverlay.getBoundingClientRect();
  const overlayHeight = calenderOverlayRect.height;

  if (calenderOverlay) {
    calenderInput.blur();
    calenderOverlay.focus();

    const viewportHeight = window.innerHeight;
    const inputRect = calenderInput.getBoundingClientRect();
    const inputHeight = inputRect.height;

    // Set top position based on viewport position
    if (showOnBottom) {
      calenderOverlay.style.top = `${inputHeight + 5}px`;
    } else if (inputRect.top + overlayHeight + inputHeight + 5 < viewportHeight) {
      calenderOverlay.style.top = `${inputHeight + 5}px`;
      if (isCalenderInsideOverlay) {
        calenderOverlay.style.position = "fixed";
        calenderOverlay.style.width = `${inputRect.width}px`;
        calenderOverlay.style.minWidth = `${inputRect.width}px`;
        calenderOverlay.style.top = `${inputRect.bottom + 5}px`;
        calenderOverlay.style.left = `${inputRect.left}px`;
      }
    } else if (isCalenderInsideOverlay) {
      calenderOverlay.style.position = "fixed";
      calenderOverlay.style.width = `${inputRect.width}px`;
      calenderOverlay.style.minWidth = `${inputRect.width}px`;
      calenderOverlay.style.top = `${inputRect.top - overlayHeight - 5}px`;
      calenderOverlay.style.left = `${inputRect.left}px`;
    } else {
      calenderOverlay.style.top = `-${overlayHeight + 5}px`;
    }
    if (calendarLeftAlign) {
      calenderOverlay.style.left = `-${calenderOverlayRect.width - inputRect.width}px`;
      if (isCalenderInsideOverlay) {
        calenderOverlay.style.position = "fixed";
        // calenderOverlay.style.width = `${inputRect.width}px`;
        calenderOverlay.style.minWidth = `${inputRect.width}px`;
        calenderOverlay.style.top = `${inputRect.bottom + 5}px`;
        calenderOverlay.style.left = `${
          inputRect.left - calenderOverlayRect.width + inputRect.width
        }px`;
      }
    }
  }
};

/**
 * Determines if a text color will be readable on a background color
 * Returns either the provided text color if readable, or black/white based on background
 */
export const getReadableTextColor = (backgroundColor: string, textColor: string): string => {
  // Convert hex to RGB
  const convertHexToRgb = (hex: string): { r: number; g: number; b: number } => {
    // Remove # if present
    const cleanHex = hex.replace("#", "");

    // Handle both 3-digit and 6-digit hex
    const r = parseInt(
      cleanHex.length === 3 ? cleanHex[0] + cleanHex[0] : cleanHex.slice(0, 2),
      16,
    );
    const g = parseInt(
      cleanHex.length === 3 ? cleanHex[1] + cleanHex[1] : cleanHex.slice(2, 4),
      16,
    );
    const b = parseInt(
      cleanHex.length === 3 ? cleanHex[2] + cleanHex[2] : cleanHex.slice(4, 6),
      16,
    );

    return { r, g, b };
  };

  // Calculate relative luminance
  const getLuminance = (r: number, g: number, b: number): number => {
    const [rs, gs, bs] = [r, g, b].map((c) => {
      c /= 255;
      return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
  };

  // Calculate contrast ratio
  const getContrastRatio = (l1: number, l2: number): number => {
    const lighter = Math.max(l1, l2);
    const darker = Math.min(l1, l2);
    return (lighter + 0.05) / (darker + 0.05);
  };

  try {
    // Convert colors to RGB
    const bgRgb = convertHexToRgb(backgroundColor);
    const textRgb = convertHexToRgb(textColor);

    // Calculate luminance
    const bgLuminance = getLuminance(bgRgb.r, bgRgb.g, bgRgb.b);
    const textLuminance = getLuminance(textRgb.r, textRgb.g, textRgb.b);

    // Calculate contrast ratio
    const contrastRatio = getContrastRatio(bgLuminance, textLuminance);

    // WCAG 2.0 requirements:
    // 4.5:1 for normal text
    // 3:1 for large text
    const MINIMUM_CONTRAST = 2;

    if (contrastRatio >= MINIMUM_CONTRAST) {
      return textColor; // Original text color is readable
    }

    // If original text color isn't readable, return black or white based on background
    return bgLuminance > 0.5 ? "#000000" : "#FFFFFF";
  } catch (error) {
    // Return black as fallback if there's any error in color parsing
    return "#000000";
  }
};

export const footerHeight = 5.75;

export const formLabel = (className?: string) =>
  `${className || ""} text-sm font-normal ${isDarkTheme() ? "text-white" : "text-text-Global"}`;

export const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export type DomainValidationResult = { isValid: true } | { isValid: false; error: string };

export function validateDomainName(rawValue: string): DomainValidationResult {
  const value = String(rawValue ?? "")
    .trim()
    .toLowerCase();

  // Allow clearing the domain field.
  if (!value) return { isValid: true };

  if (value.length > 63) {
    return { isValid: false, error: "Subdomain must be 63 characters or less." };
  }

  if (!/^[a-z]+$/.test(value)) {
    return {
      isValid: false,
      error:
        "Only letters (a–z) are allowed. Numbers, spaces, dots, and special characters are not permitted.",
    };
  }

  return { isValid: true };
}

export const docMapping: Record<string, string> = {
  business: "Business",
  businessFinancialWorksheet: "Business Financial Worksheet",
  businessValuationDoc: "Business Valuation Document",
  buySellAgreement: "Buy Sell Agreement",
  splitDollarAgreementNote: "Split Dollar Agreement Note",
  splitDollarAgreement: "Split Dollar Agreement",
  splitDollarAgreementStayBonus: "Split Dollar Agreement Stay Bonus",
  signedInsuranceCompanyCollateralForm: "Signed Insurance Company Collateral Form",
  // additionalReqDocument: "Additional Request Document",
  coverLetter: "Cover Letter",
  disabilityInsurance: "Disability Insurance Application",
  driverLicense: "Driver's License",
  employerOwnedConsentForm: "Employer Owned Consent Form",
  finalProposal: "Final Proposal",
  insuranceIllustration: "Insurance Illustration",
  // initialPlanFee: "Initial Plan Fee",
  lifeInsurance: "Life Insurance Application",
  medicalRecord: "Medical Records",
  remitPayment: "Remit Payment to Insurance Company",
  resolutionToAdoptKeyPersonInsurance: "Resolution to Adopt Key Person",
  shareholderAndOwnershipDoc: "Shareholder and Ownership Document",
  underwriting: "Underwriting",
  companyFinancial: "Company Financials",
  employeeInvoice: "Employee Invoice",
  employerInvoice: "Employer Invoice",
};
export const newdocMappingSection: Record<string, string> = {
  ...docMapping,
};
export const docMappingSection: Record<string, string> = {
  basicInfo: "Basic",
  businessValuation: "Business Valuation",
  disabilityInsuranceUnderwriting: "Disability Insurance Underwriting",
  legalAndPlanFinalization: "Legal & Plan Finalization",
  lifeInsuranceUnderwriting: "Life Insurance Underwriting",
  insuranceUnderwriting: "Insurance",
  planFinalization: "Finalization",
  planFees: "Plan Fees",
  // entityOwnership: "Entity Ownership",
  entityFinancials: "Entity Financials",
  insurerForms: "Insurer Forms",
  insuredFinancials: "Insured Financials",
  collateralRequirements: "Collateral Requirements",
  insuranceApplication: "Insurance Application",
  underwriting: "Underwriting",
  ownerIllustration: "Owner Illustration",
  insuranceIllustration: "Insurance Illustration",
  premiumPayment: "Premium Payment",
  delivery: "Delivery",
  formalOffer: "Formal Offer",
  financingUnderwriting: "Financing Underwriting",
  lenderClosingDocs: "Lender Closing Documents",
  // pfFinancingCollateralReq: "PF Financing Collateral Req",
  proposalFinalization: "Proposal Finalization",
  financing: "Financing",
  articleOfFormation: "Article of Formation",
  operatingAgreement: "Operating Agreement",
};
const pfCatergoryMappingSection = {
  ...docMappingSection,
  // pfFinancingCollateralReq: "PF Financing Collateral Req",
  pfEntityOwnership: "PF Basic Entity Ownership",
  pfEntityFinancial: "PF Basic Entity Financials",
  pfInsuranceUnderwriting: "PF Insurance Underwriting",
  pfInsuranceInsuredFinancials: "PF Insurance Insured Financials",
  pfFinancingUnderwriting: "PF Financing Underwriting",
  pfFinancingCollateralAdditionalReq: "PF Financing Collateral Additional Requirements",
};
const sortObjectByKey = (obj: Record<string, string>) =>
  Object.keys(obj)
    .sort()
    .reduce((acc: Record<string, string>, key: string) => {
      acc[key] = obj[key];
      return acc;
    }, {} as Record<string, string>);
const newPFDocumntNames = {
  articleOfFormation: "Article of Formation",
  profitAndLossStatements: "Profit and Loss Statements",
  taxReturns: "Tax Returns",
  operatingAgreement: "Operating Agreement",
  bankStatements: "Bank Statements",
  planFees: "Plan Fees",
  // entityFinancials: "Entity Financials",
  insurerForms: "Insurer Forms",
  insuredFinancials: "Insured Financials",
  identificationDocuments: "Identification",
  insuranceApplication: "Insurance Application",
  insuranceWorksheet: "Insurance Worksheet",
  underwriting: "Underwriting",
  ownerFinancials: "Owner Financials",
  insuranceIllustration: "Insurance Illustration",
  premiumPayment: "Premium Payment",
  delivery: "Delivery",
  formalOffer: "Formal Offer",
  financingUnderwriting: "Financing Underwriting",
  collateralRequirements: "Collateral Requirements",
  lenderClosingDocs: "Lender Closing Documents",
  proposalFinalization: "Proposal Finalization",
  business: "Business",
  businessFinancialWorksheet: "Business Financial Worksheet",
  businessValuationDoc: "Business Valuation Document",
  buySellAgreement: "Buy Sell Agreement",
  splitDollarAgreementNote: "Split Dollar Agreement Note",
  splitDollarAgreement: "Split Dollar Agreement",
  splitDollarAgreementStayBonus: "Split Dollar Agreement Stay Bonus",
  signedInsuranceCompanyCollateralForm: "Signed Insurance Company Collateral Form",
  coverLetter: "Cover Letter",
  disabilityInsurance: "Disability Insurance Application",
  driverLicense: "Driver's License Front",
  driverLicenseBack: "Driver's License Back",
  employerOwnedConsentForm: "Employer Owned Consent Form",
  finalProposal: "Final Proposal",
  // initialPlanFee: "Initial Plan Fee",
  lifeInsurance: "Life Insurance Application",
  medicalRecord: "Medical Records",
  remitPayment: "Remit Payment to Insurance Company",
  resolutionToAdoptKeyPersonInsurance: "Resolution to Adopt Key Person",
  shareholderAndOwnershipDoc: "Shareholder and Ownership Document",
  companyFinancial: "Company Financials",
  employeeInvoice: "Employee Invoice",
  employerInvoice: "Employer Invoice",
  holdHarmlessAgreement: "Hold Harmless Agreement",
  collateralAssignmentForm: "Collateral Assignment Form",
  financialStatements: "Financial Statements",
  thirdPartyVerification: "Third Party Verification",
  personalTaxReturns: "Personal Tax Returns",
  signedInsuranceIllustration: "Signed Insurance Illustration",
  creditApplication: "Credit Application",
};
export const newPFDocumntNamesMapping = sortObjectByKey(newPFDocumntNames);
export const pfdocMappingSection = sortObjectByKey(docMappingSection);
export const getUserDetails = () => {
  const userAccess = getObjectFromLocalStore("useraccess");
  return userAccess;
};
export const pfCatergoryMapping = sortObjectByKey(pfCatergoryMappingSection);
export const objectToQueryParams = (obj: Record<string, any>): string =>
  Object.keys(obj)
    .filter((key) => obj[key] != null) // Checks for both undefined and null
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");

export const hasRejectedApprovalStatus = (list: any[]) =>
  list?.some((el: any) => el.approvalStatus === ApprovalStatus.REJECTED);

export const renderClockIconIfNotUploaded = (
  isAdmin: string,
  list: any[],
  isInsurance: boolean = false,
) => {
  if (isAdmin !== USERTYPE.ADMIN && (list?.length > 0 || isInsurance)) {
    if (isInsurance) {
      return list[0]?.length > 0 ? list[0]?.approvalStatus === "rejected" : true;
    }
    return list[0]?.approvalStatus === "rejected";
  }
  if (isAdmin === USERTYPE.ADMIN && (list?.length > 0 || isInsurance)) {
    if (isInsurance) {
      return list[0]?.length > 0 ? list[0]?.approvalStatus === "pending" : false;
    }
    return list[0]?.approvalStatus === "pending";
  }
  return true;
};
export const showRemitPayment = (list: any[], userType: string) => {
  if (userType === USERTYPE.ADMIN) {
    return list?.length > 0 && list[0]?.approvalStatus === "pending";
  }
  if (userType !== USERTYPE.ADMIN) {
    return !(list?.length > 0 && list[0]?.approvalStatus === "pending");
  }
  return false;
};

export const getLightColor = (hex: string): string => {
  // Remove the hash symbol (#) if it's there
  hex = hex?.replace("#", "");

  // Convert hex to RGB
  let r: number = parseInt(hex?.slice(0, 2), 16);
  let g: number = parseInt(hex?.slice(2, 4), 16);
  let b: number = parseInt(hex?.slice(4, 6), 16);

  // Increase the brightness by 50%, or you can adjust this value
  r = Math.min(255, r + (255 - r) * 0.5);
  g = Math.min(255, g + (255 - g) * 0.5);
  b = Math.min(255, b + (255 - b) * 0.5);

  // Convert back to hex
  const lightenHex = (value: number): string => {
    const hexValue: string = Math?.round(value)?.toString(16);
    return hexValue?.length === 1 ? `0${hexValue}` : hexValue;
  };

  return `#${lightenHex(r)}${lightenHex(g)}${lightenHex(b)}`;
};

export const InteractiveProposalHeaderBgSvg = (bgColor = "#85B2F9") => {
  const svgString = `<svg width="1440" height="154" viewBox="0 0 1440 154" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_113_10816)">
<rect width="1440" height="154" transform="matrix(1 0 0 -1 0 154)" fill="${bgColor}"/>
<mask id="path-1-inside-1_113_10816" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1409.93 114.342C1435.74 128.513 1460.49 144.763 1483.72 162.791L1462.78 367.295L1462.76 367.293L1466.3 332.695C1450.23 301.533 1429.1 272.858 1405.32 249.479C1338.06 183.294 1247.29 144.483 1154.1 158.093C1121.42 162.868 1089.86 172.906 1058.27 182.951C1030.75 191.705 1003.2 200.465 974.882 205.754C892.795 221.031 800.368 222.259 716.547 208.462C716.482 208.451 716.418 208.441 716.353 208.43C716.398 208.425 716.443 208.42 716.488 208.414C769.106 202.36 821.393 192.148 870.985 173.751C898.614 163.489 924.404 149.46 950.172 135.444C973.756 122.615 997.321 109.797 1022.26 99.8858C1147.25 50.1693 1290.6 48.778 1409.93 114.342Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1409.93 114.342C1435.74 128.513 1460.49 144.763 1483.72 162.791L1462.78 367.295L1462.76 367.293L1466.3 332.695C1450.23 301.533 1429.1 272.858 1405.32 249.479C1338.06 183.294 1247.29 144.483 1154.1 158.093C1121.42 162.868 1089.86 172.906 1058.27 182.951C1030.75 191.705 1003.2 200.465 974.882 205.754C892.795 221.031 800.368 222.259 716.547 208.462C716.482 208.451 716.418 208.441 716.353 208.43C716.398 208.425 716.443 208.42 716.488 208.414C769.106 202.36 821.393 192.148 870.985 173.751C898.614 163.489 924.404 149.46 950.172 135.444C973.756 122.615 997.321 109.797 1022.26 99.8858C1147.25 50.1693 1290.6 48.778 1409.93 114.342Z" fill="url(#paint0_linear_113_10816)"/>
<path d="M1483.72 162.791L1484.33 162.001L1484.77 162.341L1484.72 162.893L1483.72 162.791ZM1409.93 114.342L1409.45 115.219L1409.45 115.219L1409.93 114.342ZM1462.78 367.295L1463.77 367.397L1463.67 368.392L1462.68 368.29L1462.78 367.295ZM1462.76 367.293L1462.66 368.288L1461.66 368.186L1461.76 367.191L1462.76 367.293ZM1466.3 332.695L1467.19 332.237L1467.33 332.501L1467.3 332.797L1466.3 332.695ZM1405.32 249.479L1404.62 250.192L1404.62 250.192L1405.32 249.479ZM1154.1 158.093L1153.96 157.104L1153.96 157.104L1154.1 158.093ZM1058.27 182.951L1057.97 181.998L1058.27 182.951ZM974.882 205.754L975.065 206.737L975.065 206.737L974.882 205.754ZM716.547 208.462L716.709 207.475L716.709 207.475L716.547 208.462ZM716.353 208.43L716.191 209.417L716.238 207.437L716.353 208.43ZM716.488 208.414L716.372 207.421L716.374 207.421L716.488 208.414ZM870.985 173.751L871.333 174.689L871.333 174.689L870.985 173.751ZM950.172 135.444L949.694 134.566L950.172 135.444ZM1022.26 99.8858L1022.63 100.815L1022.63 100.815L1022.26 99.8858ZM1483.11 163.581C1459.92 145.585 1435.21 129.364 1409.45 115.219L1410.41 113.466C1436.27 127.661 1461.07 143.94 1484.33 162.001L1483.11 163.581ZM1461.78 367.193L1482.73 162.689L1484.72 162.893L1463.77 367.397L1461.78 367.193ZM1462.86 366.298L1462.88 366.3L1462.68 368.29L1462.66 368.288L1462.86 366.298ZM1461.76 367.191L1465.31 332.593L1467.3 332.797L1463.75 367.395L1461.76 367.191ZM1465.41 333.154C1449.38 302.083 1428.32 273.495 1404.62 250.192L1406.03 248.766C1429.88 272.221 1451.07 300.983 1467.19 332.237L1465.41 333.154ZM1404.62 250.192C1337.53 184.174 1247.06 145.527 1154.25 159.083L1153.96 157.104C1247.52 143.438 1338.59 182.414 1406.03 248.766L1404.62 250.192ZM1154.25 159.082C1121.66 163.844 1090.18 173.855 1058.58 183.904L1057.97 181.998C1089.54 171.957 1121.18 161.893 1153.96 157.104L1154.25 159.082ZM1058.58 183.904C1031.06 192.655 1003.46 201.435 975.065 206.737L974.698 204.771C1002.95 199.495 1030.43 190.755 1057.97 181.998L1058.58 183.904ZM975.065 206.737C892.865 222.035 800.321 223.265 716.384 209.449L716.709 207.475C800.415 221.254 892.725 220.027 974.699 204.771L975.065 206.737ZM716.385 209.449C716.32 209.438 716.255 209.427 716.191 209.417L716.516 207.443C716.58 207.454 716.645 207.464 716.709 207.475L716.385 209.449ZM716.604 209.408C716.581 209.41 716.559 209.413 716.536 209.415C716.514 209.418 716.492 209.421 716.469 209.423L716.238 207.437C716.26 207.434 716.282 207.431 716.305 207.429C716.327 207.426 716.35 207.424 716.372 207.421L716.604 209.408ZM871.333 174.689C821.642 193.123 769.27 203.347 716.602 209.408L716.374 207.421C768.943 201.372 821.145 191.174 870.637 172.814L871.333 174.689ZM950.65 136.322C924.893 150.333 899.04 164.398 871.333 174.689L870.637 172.814C898.188 162.581 923.916 148.588 949.694 134.566L950.65 136.322ZM1022.63 100.815C997.755 110.7 974.243 123.489 950.65 136.322L949.694 134.566C973.269 121.742 996.887 108.893 1021.89 98.9565L1022.63 100.815ZM1409.45 115.219C1290.43 49.8236 1147.4 51.1876 1022.63 100.815L1021.89 98.9566C1147.11 49.1509 1290.77 47.7324 1410.41 113.466L1409.45 115.219Z" fill="url(#paint1_linear_113_10816)" mask="url(#path-1-inside-1_113_10816)"/>
<mask id="path-3-inside-2_113_10816" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M312.106 3.22014C283.135 -18.0642 255.773 -41.6968 230.546 -67.2377L288.64 -311.41L288.665 -311.405L278.836 -270.096C293.305 -229.803 314.286 -191.713 339.317 -159.609C410.136 -68.7285 513.784 -7.2182 628.759 -8.76926C669.079 -9.31625 708.888 -16.4114 748.728 -23.5121C783.446 -29.7 818.188 -35.8921 853.313 -37.7587C955.115 -43.1059 1067.18 -29.792 1166.43 0.330356C1166.51 0.35347 1166.58 0.376613 1166.66 0.399757C1166.6 0.398903 1166.55 0.398036 1166.49 0.397197C1101.83 -0.700077 1036.91 3.28713 973.943 17.6131C938.858 25.61 905.395 38.4603 871.963 51.2994C841.363 63.0506 810.787 74.7923 779.015 82.7947C619.768 122.956 446.039 101.686 312.106 3.22014Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M312.106 3.22014C283.135 -18.0642 255.773 -41.6968 230.546 -67.2377L288.64 -311.41L288.665 -311.405L278.836 -270.096C293.305 -229.803 314.286 -191.713 339.317 -159.609C410.136 -68.7285 513.784 -7.2182 628.759 -8.76926C669.079 -9.31625 708.888 -16.4114 748.728 -23.5121C783.446 -29.7 818.188 -35.8921 853.313 -37.7587C955.115 -43.1059 1067.18 -29.792 1166.43 0.330356C1166.51 0.35347 1166.58 0.376613 1166.66 0.399757C1166.6 0.398903 1166.55 0.398036 1166.49 0.397197C1101.83 -0.700077 1036.91 3.28713 973.943 17.6131C938.858 25.61 905.395 38.4603 871.963 51.2994C841.363 63.0506 810.787 74.7923 779.015 82.7947C619.768 122.956 446.039 101.686 312.106 3.22014Z" fill="url(#paint2_linear_113_10816)"/>
<path d="M230.546 -67.2377L229.834 -66.535L229.445 -66.9296L229.573 -67.4691L230.546 -67.2377ZM312.106 3.22014L312.698 2.41425L312.698 2.41445L312.106 3.22014ZM288.64 -311.41L287.668 -311.642L287.899 -312.615L288.872 -312.383L288.64 -311.41ZM288.665 -311.405L288.896 -312.378L289.869 -312.146L289.637 -311.173L288.665 -311.405ZM278.836 -270.096L277.895 -269.758L277.795 -270.038L277.863 -270.327L278.836 -270.096ZM339.317 -159.609L340.106 -160.224L340.106 -160.224L339.317 -159.609ZM628.759 -8.76926L628.772 -7.76935L628.772 -7.76935L628.759 -8.76926ZM748.728 -23.5121L748.552 -24.4966L748.728 -23.5121ZM853.313 -37.7587L853.26 -38.7573L853.261 -38.7573L853.313 -37.7587ZM1166.43 0.330356L1166.14 1.28735L1166.14 1.28726L1166.43 0.330356ZM1166.66 0.399757L1166.95 -0.557135L1166.64 1.39964L1166.66 0.399757ZM1166.49 0.397197L1166.48 1.39708L1166.48 1.39704L1166.49 0.397197ZM973.943 17.6131L973.721 16.6381L973.721 16.638L973.943 17.6131ZM871.963 51.2994L871.604 50.3659L871.963 51.2994ZM779.015 82.7947L778.77 81.8251L778.77 81.825L779.015 82.7947ZM231.257 -67.9404C256.447 -42.4372 283.769 -18.839 312.698 2.41425L311.514 4.02603C282.501 -17.2894 255.099 -40.9565 229.834 -66.535L231.257 -67.9404ZM289.613 -311.179L231.519 -67.0062L229.573 -67.4691L287.668 -311.642L289.613 -311.179ZM288.433 -310.432L288.409 -310.438L288.872 -312.383L288.896 -312.378L288.433 -310.432ZM289.637 -311.173L279.809 -269.865L277.863 -270.327L287.692 -311.636L289.637 -311.173ZM279.777 -270.434C294.212 -230.239 315.142 -192.242 340.106 -160.224L338.529 -158.994C313.431 -191.184 292.399 -229.368 277.895 -269.758L279.777 -270.434ZM340.106 -160.224C410.778 -69.5315 514.151 -8.22325 628.745 -9.76917L628.772 -7.76935C513.417 -6.21316 409.494 -67.9255 338.529 -158.994L340.106 -160.224ZM628.745 -9.76916C668.97 -10.3149 708.699 -17.3934 748.552 -24.4966L748.903 -22.5276C709.077 -15.4294 669.188 -8.31764 628.772 -7.76935L628.745 -9.76916ZM748.552 -24.4966C783.26 -30.6826 818.063 -36.8868 853.26 -38.7573L853.366 -36.7601C818.313 -34.8973 783.632 -28.7173 748.903 -22.5276L748.552 -24.4966ZM853.261 -38.7573C955.177 -44.1105 1067.36 -30.7829 1166.72 -0.626549L1166.14 1.28726C1067.01 -28.8011 955.053 -42.1012 853.365 -36.76L853.261 -38.7573ZM1166.72 -0.626635C1166.8 -0.603464 1166.87 -0.580263 1166.95 -0.557135L1166.37 1.35665C1166.29 1.33349 1166.22 1.3104 1166.14 1.28735L1166.72 -0.626635ZM1166.51 -0.602687C1166.56 -0.601836 1166.62 -0.600973 1166.67 -0.60013L1166.64 1.39964C1166.59 1.39878 1166.53 1.39791 1166.48 1.39708L1166.51 -0.602687ZM973.721 16.638C1036.79 2.28847 1101.8 -1.70077 1166.51 -0.602662L1166.48 1.39704C1101.87 0.300611 1037.03 4.28579 974.165 18.5882L973.721 16.638ZM871.604 50.3659C905.026 37.531 938.554 24.6535 973.721 16.6381L974.165 18.5881C939.161 26.5665 905.765 39.3896 872.321 52.2329L871.604 50.3659ZM778.77 81.825C810.475 73.8397 840.995 62.1207 871.604 50.3659L872.321 52.2329C841.731 63.9805 811.1 75.7449 779.259 83.7644L778.77 81.825ZM312.698 2.41445C446.348 100.672 619.757 121.927 778.77 81.8251L779.259 83.7643C619.778 123.984 445.73 102.699 311.514 4.02583L312.698 2.41445Z" fill="url(#paint3_linear_113_10816)" mask="url(#path-3-inside-2_113_10816)"/>
<mask id="path-5-inside-3_113_10816" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1431.01 141.029C1448.93 151.715 1466.11 164.003 1482.2 177.667L1466.12 334.68L1466.1 334.678L1466.3 332.76C1450.22 301.597 1429.09 272.922 1405.32 249.544C1338.05 183.358 1247.28 144.547 1154.09 158.157C1131.27 161.493 1108.98 167.397 1086.86 174.077C1094.57 169.687 1102.18 165.085 1109.8 160.484C1126.36 150.476 1142.91 140.476 1160.39 132.697C1248.03 93.6733 1348.15 91.5868 1431.01 141.029Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1431.01 141.029C1448.93 151.715 1466.11 164.003 1482.2 177.667L1466.12 334.68L1466.1 334.678L1466.3 332.76C1450.22 301.597 1429.09 272.922 1405.32 249.544C1338.05 183.358 1247.28 144.547 1154.09 158.157C1131.27 161.493 1108.98 167.397 1086.86 174.077C1094.57 169.687 1102.18 165.085 1109.8 160.484C1126.36 150.476 1142.91 140.476 1160.39 132.697C1248.03 93.6733 1348.15 91.5868 1431.01 141.029Z" fill="url(#paint4_linear_113_10816)"/>
<path d="M1482.2 177.667L1482.85 176.905L1483.25 177.245L1483.19 177.769L1482.2 177.667ZM1431.01 141.029L1430.5 141.888L1430.5 141.888L1431.01 141.029ZM1466.12 334.68L1467.11 334.782L1467.01 335.759L1466.04 335.676L1466.12 334.68ZM1466.1 334.678L1466.01 335.675L1465 335.589L1465.1 334.576L1466.1 334.678ZM1466.3 332.76L1467.18 332.301L1467.32 332.566L1467.29 332.862L1466.3 332.76ZM1405.32 249.544L1404.62 250.257L1404.62 250.257L1405.32 249.544ZM1154.09 158.157L1153.95 157.168L1153.95 157.168L1154.09 158.157ZM1086.86 174.077L1087.15 175.034L1086.36 173.207L1086.86 174.077ZM1109.8 160.484L1110.31 161.34L1109.8 160.484ZM1160.39 132.697L1160.8 133.611L1160.8 133.611L1160.39 132.697ZM1481.55 178.429C1465.5 164.801 1448.37 152.545 1430.5 141.888L1431.52 140.17C1449.49 150.885 1466.71 163.206 1482.85 176.905L1481.55 178.429ZM1465.12 334.578L1481.2 177.565L1483.19 177.769L1467.11 334.782L1465.12 334.578ZM1466.18 333.682L1466.2 333.683L1466.04 335.676L1466.01 335.675L1466.18 333.682ZM1465.1 334.576L1465.3 332.658L1467.29 332.862L1467.09 334.78L1465.1 334.576ZM1465.41 333.218C1449.38 302.148 1428.31 273.559 1404.62 250.257L1406.02 248.831C1429.87 272.286 1451.06 301.047 1467.18 332.301L1465.41 333.218ZM1404.62 250.257C1337.52 184.238 1247.05 145.592 1154.24 159.147L1153.95 157.168C1247.52 143.503 1338.58 182.478 1406.02 248.831L1404.62 250.257ZM1154.24 159.147C1131.48 162.472 1109.25 168.359 1087.15 175.034L1086.57 173.119C1108.71 166.434 1131.05 160.514 1153.95 157.168L1154.24 159.147ZM1110.31 161.34C1102.7 165.94 1095.08 170.549 1087.35 174.946L1086.36 173.207C1094.06 168.826 1101.67 164.23 1109.28 159.629L1110.31 161.34ZM1160.8 133.611C1143.38 141.36 1126.88 151.327 1110.31 161.34L1109.28 159.629C1125.83 149.626 1142.43 139.593 1159.99 131.783L1160.8 133.611ZM1430.5 141.888C1347.97 92.6436 1248.2 94.692 1160.8 133.611L1159.98 131.784C1247.86 92.6546 1348.33 90.5299 1431.52 140.17L1430.5 141.888Z" fill="url(#paint5_linear_113_10816)" mask="url(#path-5-inside-3_113_10816)"/>
<mask id="path-7-inside-4_113_10816" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M290.862 -32.4566C270.879 -48.2604 252.062 -65.8838 234.772 -84.9988L279.375 -272.469L279.4 -272.463L278.855 -270.173C293.324 -229.88 314.305 -191.79 339.336 -159.686C410.155 -68.8053 513.802 -7.29503 628.777 -8.84608C656.942 -9.22817 684.857 -12.8054 712.708 -17.3477C702.672 -13.27 692.717 -8.91887 682.766 -4.56938C661.118 4.89218 639.488 14.3461 617.078 20.9621C504.753 54.1621 383.242 40.6563 290.862 -32.4566Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M290.862 -32.4566C270.879 -48.2604 252.062 -65.8838 234.772 -84.9988L279.375 -272.469L279.4 -272.463L278.855 -270.173C293.324 -229.88 314.305 -191.79 339.336 -159.686C410.155 -68.8053 513.802 -7.29503 628.777 -8.84608C656.942 -9.22817 684.857 -12.8054 712.708 -17.3477C702.672 -13.27 692.717 -8.91887 682.766 -4.56938C661.118 4.89218 639.488 14.3461 617.078 20.9621C504.753 54.1621 383.242 40.6563 290.862 -32.4566Z" fill="url(#paint6_linear_113_10816)"/>
<path d="M234.772 -84.9988L234.03 -84.328L233.677 -84.7183L233.799 -85.2302L234.772 -84.9988ZM290.862 -32.4566L291.482 -33.241L291.483 -33.2407L290.862 -32.4566ZM279.375 -272.469L278.403 -272.7L278.63 -273.655L279.589 -273.445L279.375 -272.469ZM279.4 -272.463L279.613 -273.44L280.608 -273.223L280.373 -272.232L279.4 -272.463ZM278.855 -270.173L277.914 -269.835L277.813 -270.115L277.882 -270.404L278.855 -270.173ZM339.336 -159.686L340.125 -160.301L340.125 -160.301L339.336 -159.686ZM628.777 -8.84608L628.791 -7.84618L628.791 -7.84617L628.777 -8.84608ZM712.708 -17.3477L712.547 -18.3346L713.084 -16.4212L712.708 -17.3477ZM682.766 -4.56938L683.166 -3.65309L682.766 -4.56938ZM617.078 20.9621L616.794 20.0031L616.795 20.003L617.078 20.9621ZM235.514 -85.6696C252.767 -66.5953 271.543 -49.01 291.482 -33.241L290.242 -31.6723C270.215 -47.5108 251.357 -65.1722 234.03 -84.328L235.514 -85.6696ZM280.348 -272.237L235.745 -84.7673L233.799 -85.2302L278.403 -272.7L280.348 -272.237ZM279.186 -271.486L279.162 -271.492L279.589 -273.445L279.613 -273.44L279.186 -271.486ZM280.373 -272.232L279.828 -269.941L277.882 -270.404L278.427 -272.695L280.373 -272.232ZM279.796 -270.511C294.23 -230.315 315.16 -192.319 340.125 -160.301L338.547 -159.071C313.449 -191.26 292.418 -229.445 277.914 -269.835L279.796 -270.511ZM340.125 -160.301C410.797 -69.6083 514.169 -8.30007 628.764 -9.84599L628.791 -7.84617C513.436 -6.28999 409.513 -68.0024 338.547 -159.071L340.125 -160.301ZM628.764 -9.84599C656.856 -10.2271 684.715 -13.7954 712.547 -18.3346L712.869 -16.3607C685 -11.8153 657.028 -8.22925 628.791 -7.84618L628.764 -9.84599ZM682.365 -5.48568C692.314 -9.83429 702.281 -14.1907 712.332 -18.2741L713.084 -16.4212C703.062 -12.3492 693.119 -8.00346 683.166 -3.65309L682.365 -5.48568ZM616.795 20.003C639.135 13.4078 660.708 3.9803 682.365 -5.48568L683.166 -3.65309C661.529 5.80406 639.842 15.2845 617.361 21.9212L616.795 20.003ZM291.483 -33.2407C383.559 39.6322 504.717 53.1298 616.794 20.0031L617.361 21.9211C504.789 55.1943 382.924 41.6804 290.241 -31.6725L291.483 -33.2407Z" fill="url(#paint7_linear_113_10816)" mask="url(#path-7-inside-4_113_10816)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M-109.072 156.53C-132.801 173.963 -155.212 193.32 -175.874 214.239L-128.292 414.229L-128.272 414.225L-136.322 380.391C-124.471 347.389 -107.287 316.19 -86.7848 289.896C-28.7807 215.46 56.1124 165.08 150.283 166.35C183.308 166.798 215.913 172.609 248.544 178.425C276.98 183.493 305.436 188.565 334.205 190.094C417.586 194.474 509.376 183.569 590.664 158.897C590.726 158.878 590.788 158.859 590.851 158.84C590.806 158.841 590.761 158.842 590.716 158.842C537.758 159.741 484.583 156.475 433.007 144.742C404.27 138.192 376.863 127.667 349.48 117.151C324.417 107.526 299.374 97.9087 273.351 91.3543C142.919 58.4602 0.625774 75.8817 -109.072 156.53Z" fill="url(#paint8_linear_113_10816)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M-126.472 185.751C-142.839 198.695 -158.252 213.13 -172.413 228.786L-135.88 382.334L-135.86 382.329L-136.307 380.453C-124.456 347.452 -107.272 316.253 -86.7695 289.959C-28.7654 215.523 56.1277 165.143 150.298 166.413C173.367 166.726 196.231 169.656 219.042 173.376C210.822 170.036 202.668 166.473 194.518 162.91C176.787 155.161 159.071 147.417 140.716 141.998C48.7158 114.806 -50.8083 125.868 -126.472 185.751Z" fill="url(#paint9_linear_113_10816)"/>
</g>
<defs>
<linearGradient id="paint0_linear_113_10816" x1="1300.32" y1="-1424.81" x2="2160.04" y2="-398.002" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.6"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint1_linear_113_10816" x1="1085.39" y1="328.649" x2="1113.74" y2="51.8195" gradientUnits="userSpaceOnUse">
<stop stop-color="#F2F2F2" stop-opacity="0.4"/>
<stop offset="1" stop-color="#EEEEEE" stop-opacity="0.1"/>
</linearGradient>
<linearGradient id="paint2_linear_113_10816" x1="198.312" y1="1883.72" x2="-677.856" y2="503.234" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.6"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint3_linear_113_10816" x1="739.236" y1="-204.203" x2="660.595" y2="126.325" gradientUnits="userSpaceOnUse">
<stop stop-color="#F2F2F2" stop-opacity="0.4"/>
<stop offset="1" stop-color="#EEEEEE" stop-opacity="0.1"/>
</linearGradient>
<linearGradient id="paint4_linear_113_10816" x1="1426.62" y1="-1032.52" x2="2054.61" y2="-520.886" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.6"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint5_linear_113_10816" x1="1270.32" y1="314.629" x2="1292.08" y2="102.086" gradientUnits="userSpaceOnUse">
<stop stop-color="#F2F2F2" stop-opacity="0.4"/>
<stop offset="1" stop-color="#EEEEEE" stop-opacity="0.1"/>
</linearGradient>
<linearGradient id="paint6_linear_113_10816" x1="108.253" y1="1388.69" x2="-569.917" y2="668.855" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.6"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint7_linear_113_10816" x1="513.158" y1="-216.847" x2="452.779" y2="36.9249" gradientUnits="userSpaceOnUse">
<stop stop-color="#F2F2F2" stop-opacity="0.4"/>
<stop offset="1" stop-color="#EEEEEE" stop-opacity="0.1"/>
</linearGradient>
<linearGradient id="paint8_linear_113_10816" x1="-202.276" y1="-1383.7" x2="-919.904" y2="-253.008" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.6"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint9_linear_113_10816" x1="-276.039" y1="-978.241" x2="-831.496" y2="-388.66" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.6"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<clipPath id="clip0_113_10816">
<rect width="1440" height="154" fill="white" transform="matrix(1 0 0 -1 0 154)"/>
</clipPath>
</defs>
</svg>
`;

  return svgString;
};

export const fundingOptions = (color: string) => [
  {
    name: "Life",
    id: "LIFE",
    indicator: true,
    indicatorColor: color,
  },
  {
    name: "Disability",
    id: "DISABILITY",
    indicator: true,
    indicatorColor: `${color}cc`, // Reduced opacity by 0.8
  },
  {
    name: "Plan Fees",
    id: "ADMIN_FEES",
    indicator: true,
    indicatorColor: `${color}99`, // Reduced opacity by 0.8
  },
  {
    name: "Origination Fees",
    id: "PLAN_ORIGINATION_FEES",
    indicator: true,
    indicatorColor: `${color}66`, // Reduced opacity by 0.8
  },
];
export const projectionOptions = (color: string) => [
  {
    name: "Shareholder Value",
    id: "BUSINESS_VALUE",
    indicator: true,
    indicatorColor: "#808080", // Reduced opacity by 0.8
  },
  {
    name: "Death",
    id: "DEATH_BENEFIT",
    indicator: true,
    indicatorColor: `${color}cc`,
  },
  {
    name: "Disability",
    id: "DISABILITY_BENEFIT",
    indicator: true,
    indicatorColor: `${color}99`, // Reduced opacity by 0.8
  },
];
export const projectionBSOptions = (color: string) => [
  {
    name: "Death Benefit",
    id: "DEATH_BENEFIT",
    indicator: true,
    indicatorColor: `${color}cc`, // Reduced opacity by 0.8
  },
  {
    name: "Disability Benefit",
    id: "DISABILITY_BENEFIT",
    indicator: true,
    indicatorColor: `${color}99`, // Reduced opacity by 0.8
  },
  {
    name: "Shareholder Value",
    id: "BUSINESS_VALUE",
    indicator: true,
    indicatorColor: "#808080", // Reduced opacity by 0.8
  },
];

export const projectionKPOptions = (color: string) => [
  {
    name: "Death Benefit",
    id: "DEATH_BENEFIT",
    indicator: true,
    indicatorColor: color,
  },
  {
    name: "Living Benefit",
    id: "CI_BENEFIT",
    indicator: true,
    indicatorColor: `${color}cc`, // Reduced opacity by 0.8
  },
  {
    name: "Disability Benefit",
    id: "DISABILITY_BENEFIT",
    indicator: true,
    indicatorColor: `${color}99`, // Reduced opacity by 0.8
  },
  {
    name: "Key Person(s) Value",
    id: "KEY_EMPLOYEE",
    indicator: true,
    indicatorColor: "#808080",
  },
];
export const fundingSDOptions = (color: string) => [
  {
    name: "Employee Premium",
    id: "EMPLOYEE_PREMIUM",
    indicator: true,
    indicatorColor: `${color}`, // Original color
  },
  {
    name: "Employer Premium",
    id: "EMPLOYER_PREMIUM",
    indicator: true,
    indicatorColor: `${color}cc`, // Reduced opacity by 0.8
  },
  {
    name: "Interest Payment",
    id: "EMPLOYEE_INTEREST_PAYMENT",
    indicator: true,
    indicatorColor: `${color}99`, // Reduced opacity by 0.8
  },
  {
    name: "Plan Fees",
    id: "ADMIN_FEES",
    indicator: true,
    indicatorColor: `${color}66`, // Reduced opacity by 0.8
  },
  {
    name: "Origination Fees",
    id: "PLAN_ORIGINATION_FEES",
    indicator: true,
    indicatorColor: `${color}33`, // Further reduced opacity
  },
];
export const fundingPFOptions = (color: string) => [
  {
    name: "Premium",
    id: "CLIENT_PREMIUM",
    indicator: true,
    indicatorColor: `${color}`, // Original color
  },
  {
    name: "Financed Premium",
    id: "FINANCED_PREMIUM",
    indicator: true,
    indicatorColor: `${color}cc`, // Reduced opacity by 0.8
  },
  {
    name: "Interest Payment",
    id: "EMPLOYEE_INTEREST_PAYMENT",
    indicator: true,
    indicatorColor: `${color}99`, // Reduced opacity by 0.6
  },
  {
    name: "Plan Fees",
    id: "ADMIN_FEES",
    indicator: true,
    indicatorColor: `${color}66`, // Reduced opacity by 0.4
  },
  {
    name: "Origination Fees",
    id: "PLAN_ORIGINATION_FEES",
    indicator: true,
    indicatorColor: `${color}33`, // Further reduced opacity
  },
];
export const fundingSDOptionsSummary = (color: string) => [
  {
    name: "Income",
    id: "INCOME",
    indicator: true,
    indicatorColor: `${color}`, // Reduced opacity by 0.8
  },
  {
    name: "Death Benefits",
    id: "DEATH_BENEFIT",
    indicator: true,
    indicatorColor: `${color}cc`, // Further reduced opacity
  },
];
export const projectionSDOptions = (color: string) => [
  {
    name: "Income",
    id: "INCOME",
    indicator: true,
    indicatorColor: `${color}`,
  },
  {
    name: "Account Value",
    id: "ACCOUNT_VALUE",
    indicator: true,
    indicatorColor: `${color}cc`,
  },
  {
    name: "Surrender Value",
    id: "CASH_VALUE",
    indicator: true,
    indicatorColor: `${color}88`,
  },
  {
    name: "Death Benefit",
    id: "DEATH_BENEFIT",
    indicator: true,
    indicatorColor: `${color}66`,
  },
  {
    name: "Financing",
    id: "LOAN",
    indicator: true,
    indicatorColor: "#808080",
  },
];

export const projectionPFOptions = (color: string) => [
  {
    name: "Account Value",
    id: "ACCUMULATED_VALUE",
    indicator: true,
    indicatorColor: `${color}`,
  },
  {
    name: "Surrender Value",
    id: "CASH_VALUE",
    indicator: true,
    indicatorColor: `${color}cc`,
  },
  {
    name: "Stress Surrender Value",
    id: "STRESSED_CASH_VALUE",
    indicator: true,
    indicatorColor: `${color}99`,
  },
  {
    name: "Financing",
    id: "LOAN",
    indicator: true,
    indicatorColor: "#808080",
  },
  {
    name: "Death Benefit",
    id: "DEATH_BENEFIT",
    indicator: true,
    indicatorColor: `${color}66`,
  },
  {
    name: "Annual Income",
    id: "ANNUAL_INCOME",
    indicator: true,
    indicatorColor: `${color}44`,
  },
  {
    name: "Total Income",
    id: "TOTAL_INCOME",
    indicator: true,
    indicatorColor: `${color}22`,
  },
  {
    name: "Outside Collateral Requirement",
    id: "OUTSIDE_COLLATERAL_REQUIREMENT",
    indicator: true,
    indicatorColor: `${color}11`,
  },
];

export const getThemeColors = (branding: any) => {
  const [defaultPrimaryColor, defaultSecondaryColor] =
    INTERACTIVEPROPOSALBRANDINGCOLORS.DEFAULT.split(",");
  const [addonPrimaryColor] = INTERACTIVEPROPOSALBRANDINGCOLORS.ADDON.split(",");

  const userAccess = getObjectFromLocalStore("useraccess");
  const {
    agentProfile,
    allBrandingData,
    isAgencyManager,
    isSubAgencyManager,
    ipBrandingSelector,
    agencyBrandingData,
  } = useIPContext();

  if (userAccess?.userType === USERTYPE.AGENT) {
    if (ipBrandingSelector === "FIRM") {
      if (isAgencyManager || isSubAgencyManager) {
        if (agencyBrandingData?.agency?.currentBranding !== "iapp") {
          const agencyBranding =
            agencyBrandingData?.agency?.currentBranding === "parentAgency"
              ? agencyBrandingData?.agency?.parentAgency?.AgencyBrandings?.[0]
              : agencyBrandingData?.agency?.AgencyBrandings?.[0];
          const themed = getThemedPrimarySecondaryFromSource(
            agencyBranding,
            defaultPrimaryColor,
            defaultSecondaryColor,
          );
          return {
            primaryColor: themed.primaryColor,
            secondaryColor: themed.secondaryColor,
            ipTooltipColor: themed.primaryColor || addonPrimaryColor,
          };
        }
        const userThemed = getThemedPrimarySecondaryFromSource(
          branding,
          defaultPrimaryColor,
          defaultSecondaryColor,
        );
        return {
          primaryColor: defaultPrimaryColor,
          secondaryColor: defaultSecondaryColor,
          ipTooltipColor: userThemed.primaryColor || addonPrimaryColor,
        };
      }

      if (agentProfile?.subscription === "Elite" || agentProfile?.subscription === "elite") {
        const agentBrandingData = allBrandingData?.brandingData?.find(
          (el: any) => el?.userType === allBrandingData?.currentBranding,
        );
        const themed = getThemedPrimarySecondaryFromSource(
          agentBrandingData,
          defaultPrimaryColor,
          defaultSecondaryColor,
        );
        return {
          primaryColor: themed.primaryColor,
          secondaryColor: themed.secondaryColor,
          ipTooltipColor: themed.primaryColor || addonPrimaryColor,
        };
      }
    }

    if (agentProfile?.subscription === "Elite" || agentProfile?.subscription === "elite") {
      const userThemed = getThemedPrimarySecondaryFromSource(
        branding,
        defaultPrimaryColor,
        defaultSecondaryColor,
      );
      return {
        primaryColor: defaultPrimaryColor,
        secondaryColor: defaultSecondaryColor,
        ipTooltipColor: userThemed.primaryColor || addonPrimaryColor,
      };
    }
  }
  const themed = getThemedPrimarySecondaryFromSource(
    branding,
    defaultPrimaryColor,
    defaultSecondaryColor,
  );
  return {
    primaryColor: themed.primaryColor,
    secondaryColor: themed.secondaryColor,
    ipTooltipColor: themed.primaryColor || addonPrimaryColor,
  };
};

export const getThemeBasedIAPPBranding = (
  branding: any,
  isAgencyManagerActive: boolean,
  isDarkMode: boolean,
  isCollapsed: boolean,
  forPDF: boolean = false,
) => {
  const userAccess = getObjectFromLocalStore("useraccess");
  const { allBrandingData, ipBrandingSelector, agencyBrandingData } = useIPContext();

  const selectedBranding = allBrandingData?.brandingData?.find(
    (el: any) => el?.userType === allBrandingData?.currentBranding,
  );

  if (userAccess?.userType === USERTYPE.AGENT && ipBrandingSelector === "FIRM") {
    if (isAgencyManagerActive) {
      if (agencyBrandingData?.agency?.currentBranding !== "iapp") {
        const agencyBranding =
          agencyBrandingData?.agency?.currentBranding === "parentAgency"
            ? agencyBrandingData?.agency?.parentAgency?.AgencyBrandings?.[0]
            : agencyBrandingData?.agency?.AgencyBrandings?.[0];

        if (isCollapsed) {
          const darkLogo = agencyBranding?.secondaryLogoDark || IAPPLogoDarkIcon;

          const lightLogo =
            agencyBranding?.secondaryLogo ||
            (process.env.REACT_APP_ENVIRONMENT === "PROD"
              ? `${process.env.REACT_APP_ASSET_URL_PROD}/bee_icon.png`
              : `${process.env.REACT_APP_ASSET_URL_DEV}/BEE+ICON.png`);

          return isDarkMode ? darkLogo : lightLogo;
        }

        const darkLogo = agencyBranding?.primaryLogoDark || IappDarkModeLogo;
        const lightLogo = agencyBranding?.primaryLogo || IappLightModeLogo;
        return isDarkMode ? darkLogo : lightLogo;
      }
      if (isCollapsed) {
        return isDarkMode
          ? IAPPLogoDarkIcon
          : process.env.REACT_APP_ENVIRONMENT === "PROD"
          ? `${process.env.REACT_APP_ASSET_URL_PROD}/bee_icon.png`
          : `${process.env.REACT_APP_ASSET_URL_DEV}/BEE+ICON.png`;
      }
      return forPDF ? IAppLogoWithText : isDarkMode ? IappDarkModeLogo : IappLightModeLogo;
    }

    if (selectedBranding) {
      if (isCollapsed) {
        const darkLogo = selectedBranding?.secondaryLogoDark || IAPPLogoDarkIcon;

        const lightLogo =
          selectedBranding?.secondaryLogo ||
          (process.env.REACT_APP_ENVIRONMENT === "PROD"
            ? `${process.env.REACT_APP_ASSET_URL_PROD}/bee_icon.png`
            : `${process.env.REACT_APP_ASSET_URL_DEV}/BEE+ICON.png`);

        return isDarkMode ? darkLogo : lightLogo;
      }

      const darkLogo = selectedBranding?.primaryLogoDark || IappDarkModeLogo;
      const lightLogo =
        selectedBranding?.primaryLogo || (forPDF ? IAppLogoWithText : IappLightModeLogo);
      return isDarkMode ? darkLogo : lightLogo;
    }
  }

  if (userAccess?.userType === USERTYPE.CONTACT) {
    if (isCollapsed) {
      const darkLogo = branding?.secondaryLogoDark || IAPPLogoDarkIcon;

      const lightLogo =
        branding?.secondaryLogo ||
        (process.env.REACT_APP_ENVIRONMENT === "PROD"
          ? `${process.env.REACT_APP_ASSET_URL_PROD}/bee_icon.png`
          : `${process.env.REACT_APP_ASSET_URL_DEV}/BEE+ICON.png`);

      return isDarkMode ? darkLogo : lightLogo;
    }

    const darkLogo = branding?.primaryLogoDark || IappDarkModeLogo;
    const lightLogo = branding?.primaryLogo || IappLightModeLogo;
    return forPDF ? IAppLogoWithText : isDarkMode ? darkLogo : lightLogo;
  }

  if (isCollapsed) {
    return isDarkMode
      ? IAPPLogoDarkIcon
      : process.env.REACT_APP_ENVIRONMENT === "PROD"
      ? `${process.env.REACT_APP_ASSET_URL_PROD}/bee_icon.png`
      : `${process.env.REACT_APP_ASSET_URL_DEV}/BEE+ICON.png`;
  }
  return forPDF ? IAppLogoWithText : isDarkMode ? IappDarkModeLogo : IappLightModeLogo;
};

export const createGradient = (context: any, color: string) => {
  const chart = context?.chart;
  const { ctx, chartArea } = chart ?? {};
  if (!chartArea || !color) {
    return null;
  }
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);

  // Normalize to rgba() so both hex (#rrggbb[aa]) and rgb(a)(...) inputs work
  let r: number;
  let g: number;
  let b: number;
  let alpha = 0.5;
  const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (rgbaMatch) {
    [r, g, b] = [Number(rgbaMatch[1]), Number(rgbaMatch[2]), Number(rgbaMatch[3])];
    if (rgbaMatch[4] !== undefined) {
      alpha = Number(rgbaMatch[4]);
    }
  } else {
    // Assume hex — strip leading #, keep optional alpha channel (rrggbbaa)
    const hex = color.replace("#", "");
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
    if (hex.length >= 8) {
      alpha = parseInt(hex.substring(6, 8), 16) / 255;
    }
  }

  gradient?.addColorStop(1, `rgba(${r}, ${g}, ${b}, ${alpha})`);
  gradient?.addColorStop(0, `rgba(${r}, ${g}, ${b}, 0)`);
  return gradient;
};

export const getProposalType = (proposalType?: string) => {
  if (proposalType === ProposalTypes.KeyPersonInsurance) {
    return "Key Person";
  }
  return proposalType;
};

export const getProgressbarColorIAPBranding = (color: string) =>
  getTextColorBasedOnBG(color) === "#000000" ? "custom-progressbar-black" : "";

export const getMilestoneColor = (color: string) => {
  const colors = {
    MILESTONE_BRONZE: "#9D501B",
    BRONZE: "#9D501B",
    MILESTONE_SILVER: "#66788F",
    SILVER: "#66788F",
    MILESTONE_GOLD: "#CDA428",
    GOLD: "#CDA428",
    MILESTONE_HALL_OF_FAME: "#1581ED",
    HALL_OF_FAME: "#1581ED",
  };
  return colors[color as keyof typeof colors];
};

/**
 * Determines which badge logo to display for a milestone based on completion priority
 * Priority: Gold > Silver > Bronze
 * @param milestone - The milestone object containing badges
 * @returns Object containing the logo URL and badge name to display
 */
export const getMilestoneDisplayBadge = (milestone: any) => {
  if (!milestone?.Badges) {
    return {
      logo: milestone?.inactiveLogo || milestone?.logo,
      badgeName: null,
      completed: false,
    };
  }

  const badgePriority = ["MILESTONE_GOLD", "MILESTONE_SILVER", "MILESTONE_BRONZE"];

  // Check if any badge is completed (in priority order)
  const completedBadge = badgePriority.find((badgeName) => {
    const foundBadge = milestone.Badges.find((b: any) => b.name === badgeName);
    if (!foundBadge) return false;

    // Check if all criteria for this badge are completed
    return (
      foundBadge.BadgeCriteria?.every((criteria: any) => criteria.completed) || foundBadge.completed
    );
  });

  if (completedBadge) {
    const foundBadge = milestone.Badges.find((b: any) => b.name === completedBadge);
    return {
      logo: foundBadge?.logo,
      badgeName: completedBadge,
      completed: true,
    };
  }

  // If no badges are completed, return the inactive logo if available, otherwise milestone logo
  return {
    logo: milestone.inactiveLogo || milestone.logo,
    badgeName: null,
    completed: false,
  };
};

export const getBadgeStyle = (type: "bronze" | "silver" | "gold") => {
  const gradients = {
    gold: {
      default: "bg-gradient-to-r from-[#DBB730] to-[#C59A23]",
    },
    silver: {
      default: "bg-gradient-to-r from-[#AAAEB6] to-[#878D99]",
    },
    bronze: {
      default: "bg-gradient-to-r from-[#B6671C] to-[#9A4D1A]",
    },
  };

  return `${gradients[type].default}`;
};

export const eligibleForCreditingOptions: { label: string; value: boolean }[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const commonHeightOptions = [
  { name: "0" },
  { name: "1" },
  { name: "2" },
  { name: "3" },
  { name: "4" },
  { name: "5" },
  { name: "6" },
  { name: "7" },
  { name: "8" },
  { name: "9" },
  { name: "10" },
];

export const commonInchesOptions = [
  { name: "0" },
  { name: "1" },
  { name: "2" },
  { name: "3" },
  { name: "4" },
  { name: "5" },
  { name: "6" },
  { name: "7" },
  { name: "8" },
  { name: "9" },
  { name: "10" },
  { name: "11" },
];

export const medicalConditionsOptions = [
  { name: "Yes", code: "yes" },
  { name: "No", code: "no" },
];

export const getBlobUrlFromImageUrl = async (imageUrl: string): Promise<string> => {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    return imageUrl;
  }
};

export const getValidString = (value: unknown) =>
  typeof value === "string" && value.trim() ? value : "";

export const isValidValue = (value: unknown): boolean => {
  // Handle null and undefined
  if (value === null || value === undefined) {
    return false;
  }

  // Handle strings
  if (typeof value === "string") {
    const trimmedValue = value.trim().toLowerCase();
    return !(
      trimmedValue === "" ||
      trimmedValue === "n/a" ||
      trimmedValue === "null" ||
      trimmedValue === "undefined" ||
      trimmedValue === "nan"
    );
  }

  // Handle numbers
  if (typeof value === "number") {
    return !Number.isNaN(value);
  }

  // Handle arrays
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  // Handle objects
  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }

  // For other types (boolean, symbol, etc.), consider them valid
  return true;
};

export const limitDecimalPlaces = (value: number | string, decimalPlaces: number): number => {
  const num = parseFloat(value as string);
  if (Number.isNaN(num)) return 0;

  return Number.isInteger(num) ? num : parseFloat(num.toFixed(decimalPlaces));
};

export const getOpenOrUnresolvedComments = (comments: any[], userType: string) =>
  (comments || []).filter((comment: any) => comment.visibleTo?.includes(userType));

export const getCookieDomain = () => {
  const hostName = window.location.hostname;
  let cookieDomain;
  if (hostName.includes("iapp.io")) {
    cookieDomain = ".iapp.io";
  } else if (hostName.includes("iapp.cool")) {
    cookieDomain = ".iapp.cool";
  } else {
    cookieDomain = hostName;
  }
  return cookieDomain;
};

export function getPlanImageByType(type: string) {
  switch (type) {
    case "BS":
    case "Buy Sell":
      return buySell;
    case "KP":
    case "Key Person":
      return keyPerson;
    case "SD":
    case "Split Dollar":
      return splitDollar;
    case "PF":
    case "Premium Finance":
      return premiumFinance;
    default:
      return null;
  }
}

/** Maps UI / API plan type labels to short codes (BS, KP, SD, PF). */
export function getPlanTypeCode(planType: string): string {
  if (["PF", "BS", "SD", "KP"].includes(planType?.toUpperCase())) return planType.toUpperCase();
  const t = planType?.toLowerCase() || "";
  if (t.includes("buy") && t.includes("sell")) return "BS";
  if (t.includes("split") && t.includes("dollar")) return "SD";
  if (t.includes("premium") && t.includes("finance")) return "PF";
  if (t.includes("key") && t.includes("person")) return "KP";
  return planType?.toUpperCase() || "";
}

export function formatAsMMDDYYYY(value?: string | Date | null) {
  const trimmed = String(value ?? "")
    .trim()
    .replace(/^"|"$/g, "");
  if (!trimmed) return "—";

  // Already in MM/DD/YYYY
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) return trimmed;

  const formatted = formatDateToSubmit(value instanceof Date ? value : trimmed, "MM/dd/yyyy");
  return formatted && formatted !== "Invalid DateTime" ? formatted : trimmed;
}

export const getPlanFullName = (type: string) => {
  if (type === "BS") {
    return "Buy Sell";
  }
  if (type === "KP") {
    return "Key Person";
  }
  if (type === "SD") {
    return "Split Dollar";
  }
  if (type === "PF") {
    return "Premium Finance";
  }
  return type;
};

export const convertToNumber = (value: unknown): number => {
  if (typeof value === "number") return value;

  if (typeof value === "string") {
    const cleaned = value.replace(/,/g, "").trim();
    const num = Number(cleaned);
    return Number.isNaN(num) ? NaN : num;
  }

  const num = Number(value);
  return Number.isNaN(num) ? NaN : num;
};

export const monetaryCategories = [
  BadgeCategory.LIFE_BENEFIT,
  BadgeCategory.DISABILITY_BENEFIT,
  BadgeCategory.TOTAL_BENEFIT,
  BadgeCategory.CASH_VALUE,
  BadgeCategory.YEAR_1_COMMISSIONS,
  BadgeCategory.ONGOING_COMMISSIONS,
  BadgeCategory.TOTAL_COMMISSIONS,
  BadgeCategory.TARGET_PREMIUM,
  BadgeCategory.EXCESS_PREMIUM,
  BadgeCategory.TOTAL_PREMIUM,
  BadgeCategory.LOAN_AMOUNT,
];

// Helper function to determine if category should show $ symbol
export const shouldShowDollarSymbol = (category: string) =>
  monetaryCategories.includes(category as BadgeCategory);

// Helper function to format numbers based on category
export const formatNumberWithDollarSymbol = (value: number | bigint, category: string) => {
  if (shouldShowDollarSymbol(category)) {
    return `$${getUSANumberFormat(value, false)}`; // With $ symbol
  }
  return getUSANumberFormat(value, false); // Without $ symbol, US format
};

export const getDuplicateOrMaxKeys = (obj?: Record<string, number> | null): string[] => {
  if (!obj || typeof obj !== "object") return [];

  const validEntries = Object.entries(obj).filter(([, val]) => val !== 0);
  if (validEntries.length === 0) return [];

  const values = validEntries.map(([, val]) => val);

  const valueCount = values.reduce((acc, val) => {
    acc[val] = (acc[val] || 0) + 1;
    return acc;
  }, {} as Record<number, number>);

  const duplicates = validEntries.filter(([, val]) => valueCount[val] > 1).map(([key]) => key);

  if (duplicates.length > 0) {
    return duplicates;
  }

  const maxVal = Math.max(...values);
  return validEntries.filter(([, val]) => val === maxVal).map(([key]) => key);
};

export const getBigIntPercentage = (achieved: bigint, total: bigint): number => {
  if (total === BigInt(0)) return 100;
  return Number((achieved * BigInt(100)) / total); // Integer percentage only
};

export const isStandardBadge = (badge: string) => !!Badges?.[badge as keyof typeof Badges];

export const userTypeForAdvisor = (isAgencyManagerActive: boolean) => {
  const userDetails = getUserDetails();
  if (userDetails?.userType === USERTYPE.AGENT) {
    if (userDetails?.userType === USERTYPE.ASSISTANT) {
      return "Assistant";
    }
    if (isAgencyManagerActive && userDetails?.agencyManager) {
      if (userDetails?.parentAgencyId) {
        return "Sub Agency Manager";
      }
      return "Agency Manager";
    }
    return "Advisor";
  }
  return "";
};

export const insuranceCompanyOption = [
  { label: "National Life Group", value: "National Life Group" },
  { label: "Penn Mutual", value: "Penn Mutual" },
  { label: "Lincoln Financial Group", value: "Lincoln Financial Group" },
];

export const nicotineTobaccoUsageOptions = [
  { label: "Never", value: "Never" },
  { label: "Within last 12 months", value: "Within last 12 months" },
  { label: "Within last 24 months", value: "Within last 24 months" },
  { label: "Not used in last 24 months", value: "Not used in last 24 months" },
];

export const medicationOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];
export const getTooltipColors = (contactBranding?: any) => {
  const userAccess = getUserDetails();

  // Default colors for SA/advisor users
  const defaultPrimaryBlue = "#004781";
  const defaultSecondaryBlue = "#2563EB";

  if (
    contactBranding &&
    (userAccess?.userType === USERTYPE.CONTACT ||
      userAccess?.userType === USERTYPE.AGENT ||
      userAccess?.userType === USERTYPE.ASSISTANT)
  ) {
    // For contact users and advisors with custom branding, use advisor's branding colors
    return {
      primaryColor: contactBranding.primaryColor || defaultPrimaryBlue,
      secondaryColor: contactBranding.secondaryColor || defaultSecondaryBlue,
    };
  }

  // For SA users or users without custom branding, use primary/secondary blue
  return {
    primaryColor: defaultPrimaryBlue,
    secondaryColor: defaultSecondaryBlue,
  };
};

export const interestPaymentsOptions = [
  {
    value: "OUT_OF_POCKET_FULL",
    label: "Out-of-Pocket (Full)",
    description:
      "Interest is paid each year (or at regular intervals), which keeps the loan balance from increasing.",
  },
  {
    value: "OUT_OF_POCKET_PARTIAL",
    label: "Out-of-Pocket (Partial)",
    isOther: true,
    description:
      "A portion of the interest is paid each year, while the remaining unpaid interest is added to the loan balance, causing the loan to increase over time.",
  },
  {
    value: "CAPITALIZED",
    label: "Capitalized",
    description:
      "No interest is paid directly—it’s added to the loan, increasing the total amount owed over time.",
  },
];

export const interestPaymentsOptionsSD = [
  {
    value: "CAPITALIZED",
    label: "Capitalize",
    description:
      "No interest is paid directly—it’s added to the loan, increasing the total amount owed over time.",
  },
  {
    value: "OUT_OF_POCKET_FULL",
    label: "Out-of-Pocket (Full)",
    description:
      "Interest is paid each year (or at regular intervals), which keeps the loan balance from increasing.",
  },
  {
    value: "OUT_OF_POCKET_PARTIAL",
    label: "Out-of-Pocket (Partial)",
    isOther: true,
    description:
      "A portion of the interest is paid each year, while the remaining unpaid interest is added to the loan balance, causing the loan to increase over time.",
  },
];

export const prioritiesItems: any = [
  {
    label: "Death Benefit",
    id: 0,
    value: "Death Benefits",
  },
  {
    label: "",
    value: "Death Benefit & Neutral",
    id: 1,
  },
  {
    label: "Neutral",
    id: 2,
    value: "Neutral",
  },
  {
    label: "",
    value: "Neutral & Cash Value",
    id: 3,
  },
  {
    label: "Cash Value",
    value: "Cash Value",
    id: 4,
  },
];

export function parseSingleInput(inputArr: string[]): string | number | null {
  if (!Array.isArray(inputArr) || inputArr.length === 0) return null;

  const str = inputArr[0];

  // Check if it's a pure number
  if (!Number?.isNaN(Number(str))) {
    return Number(str);
  }

  // Match numbers after ":" or "_" (like "others:22", "YEAR_10")
  const match = str.match(/:(\d+)$|_(\d+)$/);

  if (match) {
    const num = match[1] || match[2];
    return Number(num);
  }

  // Otherwise return the original string
  return str;
}

export const incomeOptions = [
  { label: "Never", value: "NEVER", className: "w-[120px]" },
  { label: "Year 12", value: "YEAR_12", className: "w-[120px]" },
  { label: "Year 15", value: "YEAR_15", className: "w-[120px]" },
  { label: "Age 65", value: "AGE_65", className: "w-[120px]" },
  { label: "Age 70", value: "AGE_70", className: "w-[120px]" },
  { label: "Others", value: "others", className: "w-[120px]" },
];

export const getFileIconClass = (fileName: string) => {
  const ext = fileName.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "pdf":
      return "pi pi-file-pdf";
    case "doc":
    case "docx":
      return "pi pi-file-word";
    case "xls":
    case "xlsx":
    case "csv":
      return "pi pi-file-excel";
    case "ppt":
    case "pptx":
      return "pi pi-file";
    case "jpg":
    case "jpeg":
    case "png":
    case "svg":
      return "pi pi-image";
    case "zip":
      return "zip-icon";
    default:
      return "pi pi-file";
  }
};

export const getColorClasses = (
  difference: number,
): { borderColor: string; textColor: string; bgColor: string } => {
  if (difference >= 0) {
    return {
      borderColor: "border-positive",
      textColor: "text-[#1DA750]",
      bgColor: "bg-[#E4F8F0]",
    };
  }
  if (difference < 0) {
    return {
      borderColor: "border-negative",
      textColor: "text-[#FF5757]",
      bgColor: "bg-[#FFD0CE]",
    };
  }
  // difference === 0 → blue theme
  return {
    borderColor: "border-neutral",
    textColor: "text-[#2A7FFF]",
    bgColor: "bg-[#E5F0FF]",
  };
};

/**
 * Get border color based on section status
 */
export const getSectionBorderColor = (section: any): string => {
  const status = section?.sectionInfo?.status;
  if (status === "Completed") return "#22c55e";
  if (status === "Outstanding") return "#E24C4C";
  return "#004885"; // default blue
};

export const getStatusCounts = (data: any) => {
  const counts = { Outstanding: 0, Completed: 0, total: 0 };

  const traverse = (obj: any): void => {
    Object.values(obj).forEach((value) => {
      if (value && typeof value === "object") {
        const { status } = value as any;
        if (status === "Outstanding") counts.Outstanding++;
        if (status === "Completed") counts.Completed++;
        traverse(value);
      }
    });
  };

  traverse(data);
  counts.total = counts.Outstanding + counts.Completed;

  return counts;
};

export const formatToTitleCase = (str?: string) => {
  // (input) HELLO_WORLD_FROM_CHATGPT => (output) Hello World From ChatGPT
  if (!str) return "";
  const value = str?.toLowerCase();
  return value?.replace(/_/g, " ").replace(/\b\w/g, (ch) => ch.toUpperCase());
};

/**
 * Formats a person name for display as "Last, First" when given "First ... Last".
 * Leaves values that already contain a comma unchanged. Preserves placeholders like "—" or "-".
 */
export const formatLastNameCommaFirstForDisplay = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed || trimmed === "—" || trimmed === "-") return trimmed;
  if (trimmed.includes(",")) return trimmed;

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return trimmed;

  const lastName = parts[parts.length - 1];
  const firstName = parts.slice(0, -1).join(" ");
  return `${lastName}, ${firstName}`;
};

/**
 * Formats a `{ firstName, lastName }` object as "Last, First".
 * Skips missing parts and returns the provided fallback (default "-") when both are empty.
 */
export const formatLastFirstFromObject = (
  person?: { firstName?: string | null; lastName?: string | null } | null,
  fallback: string = "-",
): string => {
  const firstName = person?.firstName?.trim() || "";
  const lastName = person?.lastName?.trim() || "";
  const formatted = [lastName, firstName].filter(Boolean).join(", ");
  return formatted || fallback;
};

/**
 * Returns the ordinal suffix for a given number.
 *
 * For example:
 *  - 1 → "st"
 *  - 2 → "nd"
 *  - 3 → "rd"
 *  - 4 → "th"
 *  - 11, 12, 13 → always "th" (special English rule)
 *
 * This function helps format numbers like "1st", "2nd", "3rd", "21st", etc.
 *
 * @param n - The number for which the ordinal suffix is required
 * @returns A string representing the ordinal suffix ("st", "nd", "rd", or "th")
 */
export const getOrdinalSuffix = (n: number): string => {
  const j = n % 10;
  const k = n % 100;

  if (j === 1 && k !== 11) return "st";
  if (j === 2 && k !== 12) return "nd";
  if (j === 3 && k !== 13) return "rd";
  return "th";
};

export const isIconDisabled = (isDisabled: boolean) =>
  isDisabled ? "cursor-not-allowed pointer-events-none opacity-50" : "cursor-pointer";

/**
 * Calculates the number of full years passed from a given date until today.
 *
 * This function:
 * - Accepts any valid ISO date string (e.g. "2025-11-13T11:49:18.599Z")
 * - Validates the date before processing
 * - Computes only completed years (similar to age calculation)
 * - Returns 0 for invalid or empty inputs
 *
 * @param isoDateString - A valid ISO date string to calculate years from.
 * @returns The number of full years elapsed since the provided date.
 */
export const getYearsFromDate = (isoDateString: string | null | undefined): number => {
  if (!isoDateString) return 0;

  const inputDate = new Date(isoDateString);
  if (Number.isNaN(inputDate.getTime())) return 0;

  const today = new Date();

  let years = today.getFullYear() - inputDate.getFullYear();

  const hasNotReachedDateThisYear =
    today.getMonth() < inputDate.getMonth() ||
    (today.getMonth() === inputDate.getMonth() && today.getDate() < inputDate.getDate());

  if (hasNotReachedDateThisYear) {
    years -= 1;
  }

  return years;
};

/**
 * Calculates the elapsed years between two ISO date strings.
 *
 * Returns `null` for missing or invalid inputs and clamps negative spans to 0.
 * Pass `decimals` to control fractional precision (e.g. 1 for "12.5").
 */
export const getYearsBetweenDates = (
  startIso: string | null | undefined,
  endIso: string | null | undefined,
  decimals: number = 0,
): number | null => {
  if (!startIso || !endIso) return null;
  const start = new Date(startIso);
  const end = new Date(endIso);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;

  const diffMs = end.getTime() - start.getTime();
  if (diffMs <= 0) return 0;

  const years = diffMs / (1000 * 60 * 60 * 24 * 365.25);
  const factor = 10 ** decimals;
  return Math.round(years * factor) / factor;
};

export const getRgbaColor = (hexColor: string, opacity: number) => {
  const rgb = hexToRgb(hexColor);
  return `rgba(${rgb}, ${opacity})`;
};

export const getProfileGradientColor = (isDarkMode: boolean) => {
  const { branding } = getSessionStore("lookUpResponse") || {};
  const { secondaryColor: brandingSecondaryColor, primaryColor: brandingPrimaryColor } =
    getThemeColors(branding);
  const themeBrandingColor = isDarkMode ? brandingSecondaryColor : brandingPrimaryColor;
  const gradientStartColor = getRgbaColor(themeBrandingColor, 0.15);
  const gradientEndColor = getRgbaColor(
    isDarkMode ? brandingPrimaryColor : brandingSecondaryColor,
    0.15,
  );
  return `linear-gradient(270deg, ${gradientStartColor} 0%, ${gradientEndColor} 97.73%)`;
};
type USStateRecord = {
  name: string;
  code: string;
  flag: string;
  flagUrl: string;
};

/**
 * Returns the flag URL for a US state or territory given its two-letter code or full name.
 * - Matching is case-insensitive and ignores leading/trailing whitespace.
 * - Returns an empty string if not found or if the record lacks a flagUrl.
 */
export function getUSStateFlagUrl(codeOrName?: string | null): string {
  if (!codeOrName) {
    return "";
  }
  const trimmed = codeOrName.trim();
  if (!trimmed) {
    return "";
  }
  const upper = trimmed.toUpperCase();
  const lower = trimmed.toLowerCase();

  const match = (usStates as USStateRecord[]).find(
    (state) => state?.code?.toUpperCase() === upper || state?.name?.toLowerCase() === lower,
  );

  return match?.flagUrl ?? "";
}

/**
 * Formats a US phone number string to the standard XXX-XXX-XXXX format.
 * - Accepts any string input (e.g. "1234567890", "+1234567890", "123-456-7890")
 * - Returns "—" for empty or null inputs
 * - Returns the original string if it has less than 10 digits
 * - Returns the formatted phone number string
 */
export const formatUSPhoneNumber = (raw: string | null | undefined): string => {
  const digitsOnly = String(raw ?? "").replace(/\D/g, "");
  if (digitsOnly.length === 0) return "—";
  if (digitsOnly.length < 10) return String(raw ?? "—");
  const firstTen = digitsOnly.slice(0, 10);
  return `${firstTen.slice(0, 3)}-${firstTen.slice(3, 6)}-${firstTen.slice(6, 10)}`;
};

/**
 * Formats an address by combining address components.
 * - Filters out empty, null, or undefined values
 * - Joins address and city with a space, and state and zip with a space
 * - Joins the two groups with ", " (a single comma before the state)
 * - Converts a full state name (e.g. "Alaska") to its two-letter abbreviation (e.g. "AK")
 * - Returns "—" if all values are empty or missing
 * - Trims whitespace from each component before filtering
 *
 * @param address - Street address
 * @param city - City name
 * @param state - State name or code
 * @param zipCode - ZIP/Postal code
 * @returns Formatted address string or "—" if all fields are empty
 *
 * @example
 * formatAddress("123 Main St", "New York", "New York", "10001")
 * // Returns: "123 Main St New York, NY 10001"
 *
 * @example
 * formatAddress("123 Main St", null, "NY", "")
 * // Returns: "123 Main St, NY"
 *
 * @example
 * formatAddress(null, undefined, "", null)
 * // Returns: "—"
 */
export const formatAddress = (
  address?: string | null,
  city?: string | null,
  state?: string | null,
  zipCode?: string | null,
): string => {
  const isValid = (part?: string | null) => part && String(part).trim();

  const stateAbbreviation = state
    ? (usStates as USStateRecord[]).find(
        (usState) => usState?.name?.toLowerCase() === state.trim().toLowerCase(),
      )?.code ?? state
    : state;

  const addressCity = [address, city].filter(isValid).join(" ");
  const stateZip = [stateAbbreviation, zipCode].filter(isValid).join(" ");

  const result = [addressCity, stateZip].filter(isValid).join(", ");
  return result.length > 0 ? result : "—";
};

// Helper to lighten a hex color
export const getLighterShade = (hex: string, factor = 0.5): string => {
  if (!hex) return "#DADAFC";
  const cleanHex = hex.replace("#", "");
  const r = Math.min(
    255,
    Math.floor(
      parseInt(cleanHex.slice(0, 2), 16) + (255 - parseInt(cleanHex.slice(0, 2), 16)) * factor,
    ),
  );
  const g = Math.min(
    255,
    Math.floor(
      parseInt(cleanHex.slice(2, 4), 16) + (255 - parseInt(cleanHex.slice(2, 4), 16)) * factor,
    ),
  );
  const b = Math.min(
    255,
    Math.floor(
      parseInt(cleanHex.slice(4, 6), 16) + (255 - parseInt(cleanHex.slice(4, 6), 16)) * factor,
    ),
  );
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b
    .toString(16)
    .padStart(2, "0")}`;
};

export const timePeriodsOption = [
  { label: "1W", value: "1w", detail: "1 Week" },
  { label: "1M", value: "1m", detail: "1 Month" },
  { label: "3M", value: "3m", detail: "3 Months" },
  { label: "6M", value: "6m", detail: "6 Months" },
  { label: "YTD", value: "ytd", detail: "Year to Date" },
  { label: "1Y", value: "1y", detail: "1 Year" },
  { label: "2Y", value: "2y", detail: "2 Years" },
  { label: "5Y", value: "5y", detail: "5 Years" },
  { label: "10Y", value: "10y", detail: "10 Years" },
  { label: "All", value: "all", detail: "All" },
];

export interface BrandingPropsType {
  logo?: string;
  color?: string;
  primaryLogo?: string;
  primaryLogoDark?: string;
  primaryColor?: string;
  primaryColorDark?: string;
}

export const getBrandingByTheme = (branding: BrandingPropsType) => {
  const globalTheme = getSessionStore("globalTheme");
  const isDark = globalTheme === THEME.DARK;

  return {
    logo: isDark
      ? branding?.primaryLogoDark ?? branding?.logo
      : branding?.primaryLogo ?? branding?.logo,
    color: isDark
      ? branding?.primaryColorDark ?? (branding?.color || "#3b82f6")
      : branding?.primaryColor ?? (branding?.color || "#3b82f6"),
  };
};

export const planTypeOptions = [
  { label: "Split Dollar", value: "Split Dollar" },
  { label: "Buy Sell", value: "Buy Sell" },
  { label: "Key Person", value: "Key Person" },
  { label: "Premium Finance", value: "Premium Finance" },
];

/**
 * Format currency value to display string
 * @param value - The numeric value to format
 * @param isDecimal - Whether to include decimal places (default: true)
 */
export const formatCurrency = (
  value: number | null | undefined,
  isDecimal: boolean = true,
): string => {
  if (value === null || value === undefined) return "-";
  if (value < 0) {
    return `-$${getUSANumberFormat(Math.abs(value), isDecimal)}`;
  }
  return `$${getUSANumberFormat(value, isDecimal)}`;
};

/**
 * Remove file extension from filename
 */
export const removeFileExtension = (fileName: string): string =>
  fileName.replace(/\.[^/.]+$/, "").replace(/_/g, " ");

/**
 * Get policy month display text
 */
export const getPolicyMonthText = (item: any): string | null => {
  if (item.policyMonth !== null && item.policyMonth !== undefined) {
    return `Policy Month ${item.policyMonth}`;
  }
  // If policyMonth is null, check policyMonthValues to determine the range
  if (item.policyMonthValues && item.policyMonthValues.length > 0) {
    // For display purposes, we might want to show a representative month
    // Based on screenshot showing "Policy Month 15", this might be calculated
    // For now, return null if policyMonth is null
    return null;
  }
  return null;
};

/**
 * Check if section matches filter status
 */
export type Status = "Outstanding" | "Completed";
export const matches = (section: any, filter?: Status): boolean => {
  if (!filter) return true; // Show all if no filter
  const status: Status = (section?.sectionInfo?.status as Status) ?? "Outstanding";
  return status === filter;
};

/**
 * Calculate difference between illustrated and actual values
 */
export const calculateDifference = (illustrated: number, actual: number | null): number | null => {
  if (actual === null || actual === undefined) return null;
  return illustrated - actual;
};

/**
 * Format date string to readable format
 */
export const formatDisplayDate = (dateString: string | null | undefined): string => {
  if (!dateString || dateString === "N/A") return "N/A";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return "N/A";
  }
};

/**
 * Checks whether the given object contains the specified key.
 *
 * @param object - The object to validate.
 * @param key - The key name to check in the object.
 * @returns Returns `true` if the key exists in the object, otherwise `false`.
 *
 * @example
 * const data = { ownerFinancial: false };
 *
 * isKeyExists(data, "ownerFinancial");
 * // true
 *
 * isKeyExists(data, "policyNo");
 * // false
 */
export const isKeyExists = (object: Record<string, unknown>, key: string): boolean => {
  if (!object || typeof object !== "object") {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(object, key);
};

export const FUNDING_METHOD_LABEL: Record<string, string> = {
  IAPP_FACILITATED: "IAPP Facilitated",
  EXTERNALLY_DIRECTED: "Externally Directed",
};

export const FUNDING_MODE_LABEL: Record<string, string> = {
  ONE_TIME: "One Time",
  ANNUALLY: "Annually",
  SEMI_ANNUALLY: "Semi-Annually",
  QUARTERLY: "Quarterly",
  MONTHLY: "Monthly",
};
